window.theme = window.theme || {};

theme.config = {
  mqlSmall: false,
  mediaQuerySmall: "screen and (max-width: 749px)",
  isTouch:
    "ontouchstart" in window ||
    (window.DocumentTouch && window.document instanceof DocumentTouch) ||
    window.navigator.maxTouchPoints ||
    window.navigator.msMaxTouchPoints
      ? true
      : false,
  rtl: document.documentElement.getAttribute("dir") === "rtl" ? true : false,
};

window.promoGwpTriggerProductsInCart = (cartItems, promoGwp) => {
  const triggerProductInCart = promoGwp.triggerProductId
    ? cartItems.some((i) => i.product_id === promoGwp.triggerProductId)
    : false;
  const collectionProductInCart = promoGwp.triggerCollectionProductIds?.length
    ? cartItems.some((i) =>
        promoGwp.triggerCollectionProductIds.includes(i.product_id),
      )
    : false;
  return { triggerProductInCart, collectionProductInCart };
};

window.gwpQualifies = (cart) => {
  if (!window.promo_gwp) return false;

  const cfg = window.promo_gwp;
  const promoStart = new Date(cfg.dataStart).getTime() + cfg.timeZone * 60 * 1000;
  const promoFinish = new Date(cfg.dataEnd).getTime() + cfg.timeZone * 60 * 1000;
  const now = Date.now() + new Date().getTimezoneOffset() * 60 * 1000;

  if (now < promoStart || now > promoFinish) return false;

  const cartTotal = cfg.priceBeforeDiscount
    ? cart.original_total_price / 100
    : cart.total_price / 100;

  const spendMet = cartTotal >= cfg.priceTrigger;

  const { triggerProductInCart, collectionProductInCart } =
    window.promoGwpTriggerProductsInCart(cart.items, cfg);

  return spendMet || triggerProductInCart || collectionProductInCart;
};

theme.Currency = (function () {
  const moneyFormat = "${{amount}}"; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    let value = "";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ",";
      decimal = decimal || ".";

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      const parts = number.split(".");
      const dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands,
      );
      const centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney,
  };
})();

// Init section function when it's visible, then disable observer
theme.initWhenVisible = function (options) {
  const threshold = options.threshold ? options.threshold : 0;

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (typeof options.callback === "function") {
            options.callback();
            observer.unobserve(entry.target);
          }
        }
      });
    },
    { rootMargin: `0px 0px ${threshold}px 0px` },
  );

  observer.observe(options.element);
};

(function () {
  // Trigger events when going between breakpoints
  const mql = window.matchMedia(theme.config.mediaQuerySmall);
  theme.config.mqlSmall = mql.matches;
  mql.onchange = (e) => {
    if (e.matches) {
      theme.config.mqlSmall = true;
      document.dispatchEvent(new CustomEvent("matchSmall"));
    } else {
      theme.config.mqlSmall = false;
      document.dispatchEvent(new CustomEvent("unmatchSmall"));
    }
  };

  // Page transition
  window.addEventListener("beforeunload", () => {
    document.body.classList.add("unloading");
  });
  window.addEventListener("DOMContentLoaded", () => {
    document.body.classList.add("loaded");
  });
  window.addEventListener("pageshow", (event) => {
    // Removes unload class when returning to page via history
    if (event.persisted) {
      document.body.classList.remove("unloading");
    }
  });

  // Viewport height
  function viewportHeight() {
    const platform = navigator?.userAgentData?.platform || navigator?.platform;
    if (
      /iPad|iPhone|iPod/.test(platform) ||
      (platform === "MacIntel" && navigator.maxTouchPoints > 1)
    ) {
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`,
      );
    }
  }
  window.addEventListener("resize", viewportHeight);
  window.addEventListener("DOMContentLoaded", viewportHeight);

  if (document.body.getAttribute("data-page-rendering") !== null) {
    // Improve initial load time by skipping the rendering of offscreen content
    const observer = new IntersectionObserver(
      (entries, _observer) => {
        entries.forEach((entry) => {
          const el = entry.target;
          // Not currently in intersection area.
          if (entry.intersectionRatio == 0) {
            return;
          }
          // Trigger rendering for elements within scroll area that haven't already been marked.
          if (!el.markedVisible) {
            el.attributeStyleMap &&
              el.attributeStyleMap.set("content-visibility", "visible");
            el.markedVisible = true;
          }
        });
      },
      // Set a rendering 50px above and 100px below the main scroll area.
      { rootMargin: "50px 0px 100px 0px" },
    );
    const sections = document.querySelectorAll(
      ".shopify-section + .shopify-section",
    );
    sections.forEach((section) => {
      observer.observe(section);
    });
  }

  /*
  // Delay JavaScript until user interaction
  const loadScriptsTimer = setTimeout(loadScripts, 5000);
  const userInteractionEvents = ["mouseover", "mousemove", "keydown", "touchstart", "touchend", "touchmove", "wheel"];
  userInteractionEvents.forEach(function(event) {
    window.addEventListener(event, triggerScriptLoader, {
      passive: !0
    });
  });
  function triggerScriptLoader() {
    loadScripts();
    clearTimeout(loadScriptsTimer);
    userInteractionEvents.forEach(function(event) {
      window.removeEventListener(event, triggerScriptLoader, {
        passive: !0
      });
    });
  }
  function loadScripts() {
    document.querySelectorAll("script[data-type='lazy']").forEach(function(script) {
      script.setAttribute("src", script.getAttribute("data-src"));
    });
  }
  */
})();

// Prevent vertical scroll while using flickity sliders
(function () {
  var e = !1;
  var t;

  document.body.addEventListener("touchstart", function (i) {
    if (!i.target.closest(".flickity-slider")) {
      return (e = !1);
    }
    e = !0;
    t = {
      x: i.touches[0].pageX,
      y: i.touches[0].pageY,
    };
  });

  document.body.addEventListener(
    "touchmove",
    function (i) {
      if (e && i.cancelable) {
        var n = {
          x: i.touches[0].pageX - t.x,
          y: i.touches[0].pageY - t.y,
        };
        Math.abs(n.x) > Flickity.defaults.dragThreshold && i.preventDefault();
      }
    },
    { passive: !1 },
  );
})();

function isStorageSupported(type) {
  // Return false if we are in an iframe without access to sessionStorage
  if (window.self !== window.top) {
    return false;
  }

  const testKey = "beyours:test";
  let storage;
  if (type === "session") {
    storage = window.sessionStorage;
  }
  if (type === "local") {
    storage = window.localStorage;
  }

  try {
    storage.setItem(testKey, "1");
    storage.removeItem(testKey);
    return true;
  } catch (error) {
    // Do nothing, this may happen in Safari in incognito mode
    return false;
  }
}

function checkScrollbar() {
  const rect = document.body.getBoundingClientRect();
  return Math.round(rect.left + rect.right) < window.innerWidth;
}

function setScrollbarWidth() {
  if (checkScrollbar()) {
    const element = document.createElement("span");
    (element.className = "modal-scrollbar-measure"),
      document.body.appendChild(element);

    const width = element.getBoundingClientRect().width - element.clientWidth;
    document.body.removeChild(element);
    document.documentElement.style.setProperty(
      "--scrollbar-width",
      `${width}px`,
    );
  }
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    const charCode = event.code
      ? event.code.toUpperCase()
      : event.key.toUpperCase();
    if (charCode !== "TAB") return; // If not TAB key

    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  if (elementToFocus) elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true,
  );
}

function pauseAllMedia(exceptElement = null) {
  function _dispatchPauseEvent(element) {
    element.dispatchEvent(
      new CustomEvent("pause-all-media", {
        bubbles: true,
        detail: { source: element },
      })
    );
  }

  document.querySelectorAll(".js-youtube").forEach((video) => {
    if (video === exceptElement?.querySelector('.js-youtube') || video.classList.contains('js-exempt-all-pause-video')) return;
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*",
    );
    video.closest("video-section")?.youtubePause?.();
    _dispatchPauseEvent(video);
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    if (video === exceptElement?.querySelector('.js-vimeo') || video.classList.contains('js-exempt-all-pause-video')) return;
    video.contentWindow.postMessage('{"method":"pause"}', "*");
    video.closest("video-section")?.vimeoPause?.();
    _dispatchPauseEvent(video);
  });
  document.querySelectorAll("video").forEach((video) => {
    if (video === exceptElement || video.classList.contains('js-exempt-all-pause-video')) return;
    video.pause()
    _dispatchPauseEvent(video);
  });
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
    _dispatchPauseEvent(model);
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  const charCode = event.code
    ? event.code.toUpperCase()
    : event.key.toUpperCase();
  if (charCode !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

function filterShopifyEvent(event, domElement, callback) {
  let executeCallback = false;
  if (event.type.includes("shopify:section")) {
    if (
      domElement.hasAttribute("data-section-id") &&
      domElement.getAttribute("data-section-id") === event.detail.sectionId
    ) {
      executeCallback = true;
    }
  } else if (
    event.type.includes("shopify:block") &&
    event.target === domElement
  ) {
    executeCallback = true;
  }
  if (executeCallback) {
    callback(event);
  }
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  const method = options["method"] || "post";
  const params = options["parameters"] || {};

  const form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (const key in params) {
    const hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.postLink2 = function (path, options) {
  options = options || {};
  const method = options["method"] || "post";
  const params = options["parameters"] || {};

  const form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (const key in params) {
    for (const index in params[key]) {
      for (const key2 in params[key][index]) {
        const hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", `${key}[${index}][${key2}]`);
        hiddenField.setAttribute("value", params[key][index][key2]);
        form.appendChild(hiddenField);
      }
    }
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class QuantityInput extends HTMLElement {
  constructor() {
    super();

    this.init();
  }

  init() {
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.onInputChange = this.onInputChange.bind(this);
    this.input.addEventListener("change", this.onInputChange);

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );
  }

  onInputChange() {
    this.input.dispatchEvent(new Event("quantity-change", { bubbles: true }));
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }
}
customElements.define("quantity-input", QuantityInput);

class MenuDropdown extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      isActive: "is-active",
    };

    this.addEventListener("focusin", this.openDropdown.bind(this));
    this.addEventListener("focusout", this.closeDropdown.bind(this));
    this.addEventListener("mouseover", this.openDropdown.bind(this));
    this.addEventListener("mouseleave", this.closeDropdown.bind(this));
    this.addEventListener("click", this.preventEvent.bind(this));
  }

  openDropdown() {
    this.classList.add(this.classes.isActive);

    if (
      document.getElementsByClassName("account-text-box-dropdown-wrapper")
        .length > 0
    ) {
      document
        .getElementsByClassName("account-text-box-dropdown-wrapper")[0]
        .classList.add("hidden");
    }
  }

  closeDropdown() {
    this.classList.remove(this.classes.isActive);

    if (
      document.getElementsByClassName("account-text-box-dropdown-wrapper")
        .length > 0
    ) {
      document
        .getElementsByClassName("account-text-box-dropdown-wrapper")[0]
        .classList.remove("hidden");
    }
  }

  preventEvent(e) {
    if (
      e.target.parentNode.classList.contains("is-megamenu") ||
      e.target.parentNode.parentNode.classList.contains("is-megamenu") ||
      e.target.parentNode.classList.contains("is-menu-dropdown") ||
      e.target.parentNode.parentNode.classList.contains("is-menu-dropdown")
    ) {
      e.preventDefault();
    }
  }
}
customElements.define("menu-dropdown", MenuDropdown);

class MenuDrawer extends HTMLElement {
  constructor(props) {
    super();

    this.classes = props
      ? props.classes
      : {
          open: "menu-drawer--open",
          opening: "menu-drawer--opening",
          closing: "menu-drawer--closing",
          htmlOpen: "html-menu-drawer-open",
        };

    this.mainDetailsToggle = this.querySelector("details");
    this.miniCart = document.querySelector("mini-cart");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this)),
    );
    this.querySelectorAll(".menu-drawer__back").forEach((button) =>
      button.addEventListener("click", this.backMobileMenu.bind(this)),
    );
    this.querySelectorAll(".summary .icon-caret").forEach((button) =>
      button.addEventListener("click", this.onPreudoSummaryClick.bind(this)),
    );
    this.querySelectorAll(".header__submenu li").forEach((button) =>
      button.addEventListener("mouseover", this.onMainItemsFocusOut.bind(this)),
    );
    this.querySelectorAll(".menu-drawer__close-button").forEach((button) =>
      button.addEventListener("click", this.closeMenuDrawer.bind(this)),
    );
  }

  onKeyUp(event) {
    const charCode = event.code
      ? event.code.toUpperCase()
      : event.key.toUpperCase();
    if (charCode !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary"),
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentElement = detailsElement.parentNode;
    const submenuContainer = detailsElement.nextElementSibling;
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button"),
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus,
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      if (event.currentTarget.querySelector(".menu-drawer__menu-item")) {
        const submenuContainerMob = summaryElement.nextElementSibling;
        submenuContainerMob.classList.add("menu-opening");
      } else if (
        event.currentTarget.classList.contains("mobile-facets__summary")
      ) {
        setTimeout(() => {
          detailsElement.classList.add("menu-opening");
          summaryElement.setAttribute("aria-expanded", true);
          !reducedMotion || reducedMotion.matches
            ? addTrapFocus()
            : summaryElement.nextElementSibling.addEventListener(
                "transitionend",
                addTrapFocus,
              );
        }, 100);
      } else {
        const submenuDrawer = event.target.closest(".list-menu-drawer")?.querySelector(".list-submenu-drawer");
        if (!submenuDrawer) return;
        const ThirdIsOpen = submenuDrawer.classList.contains("menu-opening");
        const allSubmenu = parentElement.parentNode.querySelectorAll("li");
        let submenuHasActiveEl = false;

        if (parentElement.classList.contains("submenu-open")) {
          parentElement.classList.remove("submenu-open");
        } else {
          allSubmenu.forEach((element) => {
            element.classList.remove("submenu-open");
          });
          parentElement.classList.add("submenu-open");
        }

        allSubmenu.forEach((element) => {
          if (element.classList.contains("submenu-open")) {
            submenuHasActiveEl = true;
          }
        });

        setTimeout(() => {
          submenuHasActiveEl
            ? submenuDrawer.classList.add("menu-opening")
            : submenuDrawer.classList.remove("menu-opening");

          submenuDrawer.innerHTML = submenuContainer.innerHTML;
          summaryElement.setAttribute("aria-expanded", true);
        }, 100);
      }
    }
  }

  onPreudoSummaryClick(event) {
    const summaryElement = event.currentTarget.parentNode;
    const detailsElement = summaryElement.parentNode;

    if (detailsElement !== this.mainDetailsToggle) {
      if (summaryElement.querySelector(".menu-drawer__menu-item")) {
        const submenuContainerMob = summaryElement.nextElementSibling;

        submenuContainerMob.classList.toggle("menu-opening");
        summaryElement.classList.toggle("active");
      }
    }
  }

  openMenuDrawer(summaryElement) {
    setScrollbarWidth();
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);

    setTimeout(() => {
      this.onBodyClickEvent =
        this.onBodyClickEvent || this.onBodyClick.bind(this);
      document.body.addEventListener("click", this.onBodyClickEvent);
    });

    document.body.parentNode.classList.add(this.classes.htmlOpen);
    document.body.classList.add(this.classes.opening);

    this.openAnimation();
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.classList.add("menu-closing");
      removeTrapFocus(elementToFocus);

      document.body.removeEventListener("click", this.onBodyClickEvent);
      document.body.classList.remove(this.classes.open);
      document.body.classList.add(this.classes.closing);

      document.body.parentNode.classList.remove(this.classes.htmlOpen);

      this.closeAnimation(this.mainDetailsToggle);
      this.dispatchEvent(new CustomEvent("close"));

      document
        .querySelectorAll(".menu-drawer__accordion-content")
        .forEach((element) => {
          element.classList.remove("menu-opening");
        });

      document
        .querySelectorAll(".menu-drawer__menu .summary")
        .forEach((element) => {
          element.classList.remove("active");
        });
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onMainItemsFocusOut(event) {
    let hasOpen = false;
    document.querySelectorAll(".list-submenu-drawer").forEach((element) => {
      if (element.classList.contains("menu-opening")) {
        hasOpen = true;
      }
    });

    if (
      (hasOpen == true && event.target.classList.contains("list-menu__item")) ||
      (hasOpen == true && event.target.classList.contains("label"))
    ) {
      if (
        event.target.classList.contains("submenu-open") ||
        event.target.closest("li").classList.contains("submenu-open")
      ) {
        //console.log('active menu');
      } else {
        document.querySelectorAll(".list-submenu-drawer").forEach((element) => {
          element.classList.remove("menu-opening");
        });
        document.querySelectorAll(".header__submenu li").forEach((element) => {
          element.classList.remove("submenu-open");
        });
      }
    }
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  openAnimation() {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        document.body.classList.remove(this.classes.opening);
        document.body.classList.add(this.classes.open);
        document.body.parentNode.classList.add(this.classes.htmlOpen);
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        if (detailsElement === this.mainDetailsToggle) {
          document.body.classList.remove(this.classes.closing);
          document.body.parentNode.classList.remove(this.classes.htmlOpen);
          detailsElement.classList.remove("menu-closing");
        }
        detailsElement.removeAttribute("open");

        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary"),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }

  onBodyClick(event) {
    const _this = this;

    if (!this.contains(event.target)) {
      document.querySelectorAll(".list-submenu-drawer").forEach((element) => {
        element.classList.remove("menu-opening");
      });

      document.querySelectorAll(".header__submenu li").forEach((element) => {
        element.classList.remove("submenu-open");
      });

      setTimeout(function () {
        _this.closeMenuDrawer(event);
      }, 250);
    }
  }

  backMobileMenu(event) {
    event.target
      .closest(".menu-drawer__accordion-content")
      .classList.remove("menu-opening");
    setTimeout(function () {
      event.target.closest(".details").removeAttribute("open");
    }, 200);
  }
}
customElements.define("menu-drawer", MenuDrawer);

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.openCartDrawerButton = this.querySelector('details');
    this.miniCart = document.querySelector('mini-cart');
    if (!this.miniCart) console.warn("Warning: 'mini-cart' element not found in the DOM.");
    this.header = document.querySelector('header');
    this.overlay = document.querySelector('.js-body-overlay');
    this.body = document.querySelector('body');

    this.handleOverlayClick = this.handleOverlayClick.bind(this);

    this.openCartDrawerButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.toggleDrawer();
    });

    this.overlay?.addEventListener('click', this.handleOverlayClick);
  }

  toggleDrawer() {
    if (document.body.classList.contains('smart-cart--enabled')) {
      document.body.classList.add("rebuy-cart-visible");
    } else {
      const isOpening = !this.miniCart?.classList.contains('open-cart-drawer');
      this.miniCart?.classList.toggle('open-cart-drawer');
      this.header?.classList.toggle('mini-cart-open');
      this.body?.classList.toggle('overflow-hidden');

      if (isOpening && typeof GTMDataLayer !== 'undefined') {
        GTMDataLayer.fetchAndTrackCart();
      }
    }
  }

  handleOverlayClick(e) {
    e.preventDefault();
    this.miniCart?.classList.remove('open-cart-drawer');
    this.header?.classList.remove('mini-cart-open');
    this.body?.classList.remove('overflow-hidden');
  }
}
customElements.define('cart-drawer', CartDrawer);

class FacetDrawer extends MenuDrawer {
  constructor() {
    super({
      classes: {
        open: "facet-drawer--open",
        opening: "facet-drawer--opening",
        closing: "facet-drawer--closing",
      },
    });
  }
}
customElements.define("facet-drawer", FacetDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super({
      classes: {
        open: "menu-mobile--open",
        opening: "menu-mobile--opening",
        closing: "menu-mobile--closing",
      },
    });
  }
}
customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this),
    );
    this.addEventListener("keyup", (event) => {
      const charCode = event.code
        ? event.code.toUpperCase()
        : event.key.toUpperCase();
      if (charCode === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector("button");
    if (!this.button) return;

    this.button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(this.button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class VideoSection extends HTMLElement {
  constructor() {
    super();

    this.autoplay = this.dataset.autoplay === "true" && this.dataset.muted === "true";
    this.loop = this.dataset.loop === "true";
    this.muted = this.dataset.muted === "true";
    this.init();
  }

  init() {
    this.parentSelector = this.dataset.parent || ".media-wrapper";
    this.parent = this.closest(this.parentSelector);

    switch (this.dataset.type) {
      case "youtube":
        this.initYoutubeVideo();
        break;
      case "vimeo":
        this.initVimeoVideo();
        break;
      case "mp4":
        this.initMp4Video();
        break;
    }
  }

  initYoutubeVideo() {
    this.setAsLoading();
    this.loadScript("youtube").then(this.setupYoutubePlayer.bind(this));
  }

  initVimeoVideo() {
    this.setAsLoading();
    this.loadScript("vimeo").then(this.setupVimeoPlayer.bind(this));
  }

  initMp4Video() {
    const player = this.querySelector("video");
    if (!player) return;

    const promise = player.play();
    if (typeof promise !== "undefined") {
      promise.catch(() => {
        player.setAttribute("controls", "");
      });
    }

    if (this.autoplay) {
      player.classList.add("js-exempt-all-pause-video");
    }

    this.dispatchEvent(new CustomEvent("video-ready", { bubbles: true }));
  }

  loadScript(videoType) {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.async = true;
      script.onload = resolve;
      script.onerror = reject;
      script.src =
        videoType === "youtube"
          ? "//www.youtube.com/iframe_api"
          : "//player.vimeo.com/api/player.js";
      document.body.appendChild(script);
    });
  }

  setAsLoading() {
    this.parent.setAttribute("loading", true);
  }

  setAsLoaded() {
    this.parent.removeAttribute("loading");
    this.parent.setAttribute("loaded", true);
  }

  setupYoutubePlayer() {
    const videoId = this.dataset.videoId;
    const interval = setInterval(() => {
      if (window.YT) {
        window.YT.ready(() => {
          const container = document.createElement("div");
          this.appendChild(container);

          this.player = new YT.Player(container, {
            videoId,
            playerVars: {
              controls: 0,
              fs: 0,
              rel: 0,
              height: "100%",
              width: "100%",
              iv_load_policy: 3,
              html5: 1,
              loop: this.loop   ? 1 : 0,
              autoplay: this.autoplay ? 1 : 0,
              mute: this.muted  ? 1 : 0,
              playsinline: 1,
              modestbranding: 1,
              disablekb: 1
            },
            events: {
              onReady: this.onYoutubeReady.bind(this),
              onStateChange: this.onYoutubeStateChange.bind(this)
            }
          });

          clearInterval(interval);
        });
      }
    }, 50);
  }

  onYoutubeReady() {
    this.iframe = this.querySelector("iframe");
    this.iframe.setAttribute("tabindex", "-1");
    this.iframe.classList.add("js-youtube");
    if (this.autoplay) {
      this.iframe.classList.add("js-exempt-all-pause-video");
    }
    this.player.playVideo();
    this.setAsLoaded();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry =>
          entry.isIntersecting ? this.youtubePlay() : this.youtubePause()
        );
      },
      { rootMargin: "0px 0px 50px 0px" }
    );
    observer.observe(this.iframe);

    this.dispatchEvent(new CustomEvent("video-ready", { bubbles: true }));
  }

  onYoutubeStateChange(event) {
    switch (event.data) {
      case YT.PlayerState.ENDED:
        if (this.loop) {
          this.youtubePlay();
        } else {
          this.dispatchEvent(new CustomEvent("video-ended", { bubbles: true }));
        }
        break;
      case YT.PlayerState.PLAYING:
        this.setAsLoaded();
        break;
      case YT.PlayerState.BUFFERING:
        this.attemptedToPlay = true;
        break;
      case YT.PlayerState.UNSTARTED:
        if (this.attemptedToPlay) {
          this.setAsLoaded();
          this.closest(".banner")?.classList.add("video-interactable");
        }
        break;
    }
  }

  youtubePlay() {
    if (this.player?.playVideo) this.player.playVideo();
  }
  youtubePause() {
    if (this.player?.pauseVideo) this.player.pauseVideo();
  }

  setupVimeoPlayer() {
    const videoId = this.dataset.videoId;
    const interval = setInterval(() => {
      if (window.Vimeo) {
        this.player = new Vimeo.Player(this, {
          id: videoId,
          autoplay: this.autoplay,
          autopause: false,
          background: false,
          controls: false,
          loop: this.loop,
          muted: this.muted,
          height: "100%",
          width: "100%"
        });

        this.player.ready().then(this.onVimeoReady.bind(this));
        clearInterval(interval);
      }
    }, 50);
  }

  onVimeoReady() {
    this.iframe = this.querySelector("iframe");
    this.iframe.setAttribute("tabindex", "-1");
    this.iframe.classList.add("js-vimeo");
    if (this.autoplay) {
      this.iframe.classList.add("js-exempt-all-pause-video");
    }

    this.setAsLoaded();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry =>
          entry.isIntersecting ? this.vimeoPlay() : this.vimeoPause()
        );
      },
      { rootMargin: "0px 0px 50px 0px" }
    );
    observer.observe(this.iframe);

    this.player.on("ended", () => {
      if (this.loop) {
        this.vimeoPlay();
      } else {
        this.dispatchEvent(new CustomEvent("video-ended", { bubbles: true }));
      }
    });

    this.dispatchEvent(new CustomEvent("video-ready", { bubbles: true }));
  }

  vimeoPlay() {
    if (this.player?.play) this.player.play();
  }
  vimeoPause() {
    if (this.player?.pause) this.player.pause();
  }
}
customElements.define("video-section", VideoSection);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!this.poster) return;

    this.poster.addEventListener("click", this.loadContent.bind(this));
    this.addEventListener("pause-all-media", (event) => {
      const pausedEl = event.detail?.source;
      if (!pausedEl || !this.contains(pausedEl)) return;
      if (this.playPauseButton && this.updatePlayPauseButtonState) {
        this.isPlaying = false;
        this.updatePlayPauseButtonState();
      }
    });

    this.autoplay = this.dataset.autoplay === "true";
    if (this.autoplay) {
      this.loadContent();
    }
  }

  loadContent() {
    if (!this.autoplay) window.pauseAllMedia(this);
    if (this.hasAttribute("loaded")) return;

    const template = this.querySelector("template");
    const content  = document.createElement("div");
    const clone    =
      template?.content.firstElementChild.cloneNode(true) ||
      this.querySelector("video-section")?.cloneNode(true);

    content.appendChild(clone);
    const wrapper = content.querySelector("video-section") || content;

    this.setAttribute("loaded", "");
    this.appendChild(wrapper);
    wrapper.focus();

    wrapper.addEventListener("video-ended", () => {
      this.isPlaying = false;
      this.updatePlayPauseButtonState();
    });

    const btn = this.querySelector(".js-deferred-video-play-button");
    if (!btn) return;

    if (wrapper instanceof VideoSection) {
      if (wrapper.dataset.type === "mp4") {
        const video = wrapper.querySelector("video");
        video.onloadeddata = () => {
          this.poster.querySelector("img")?.classList.add("visually-hidden");
          this.poster.classList.add("is-loaded");
        };
        this.setupPlayPauseButton(btn, video || wrapper);
      } else {
        const setup = () => {
          const video = wrapper.querySelector("video");
          this.setupPlayPauseButton(btn, video || wrapper);

          this.poster.querySelector("img")?.classList.add("visually-hidden");
          this.poster.classList.add("is-loaded");
        };
        if (wrapper.querySelector("iframe")) {
          setup();
        } else {
          this.addEventListener("video-ready", setup, { once: true });
        }
      }
    }

    const muteBtn = this.querySelector(".js-deferred-video-muted-button");
    if (!muteBtn) return;

    if (wrapper instanceof VideoSection) {
      if (wrapper.dataset.type === "mp4") {
        const video = wrapper.querySelector("video");
        this.setupMuteButton(muteBtn, video || wrapper);
      } else {
        const setup = () => {
          const video = wrapper.querySelector("video");
          this.setupMuteButton(muteBtn, video || wrapper);
        };
        if (wrapper.querySelector("iframe")) {
          setup();
        } else {
          this.addEventListener("video-ready", setup, { once: true });
        }
      }
    }
  }

  setupPlayPauseButton(btn, target) {
    this.playPauseButton = btn;
    this.playPauseTarget = target;

    if (this.autoplay) {
      btn.classList.add("is-autoplay");
    }

    btn.classList.add("is-loaded");
    btn.disabled = false;
    btn.setAttribute("aria-hidden", "false");
    btn.setAttribute("tabindex", "0");

    const iconPlay  = btn.querySelector(".js-deferred-video-play-button-icon-play");
    const iconPause = btn.querySelector(".js-deferred-video-play-button-icon-pause");
    if (!iconPlay || !iconPause) return;

    this.isPlaying = (target.tagName === "VIDEO" ? !target.paused : true);

    this.updatePlayPauseButtonState = () => {
      if (this.isPlaying) {
        iconPlay.classList.add("visually-hidden");
        iconPlay.setAttribute("aria-hidden", "true");
        iconPause.classList.remove("visually-hidden");
        iconPause.setAttribute("aria-hidden", "false");
      } else {
        iconPlay.classList.remove("visually-hidden");
        iconPlay.setAttribute("aria-hidden", "false");
        iconPause.classList.add("visually-hidden");
        iconPause.setAttribute("aria-hidden", "true");
      }
    };

    if (target.tagName === "VIDEO") {
      target.addEventListener("ended", () => {
        this.isPlaying = false;
        this.updatePlayPauseButtonState();
      });
    }

    btn.addEventListener("click", () => {
      if (target.tagName === "VIDEO") {
        if (target.paused) {
          if (!this.autoplay) window.pauseAllMedia(target);
          target.play();
          this.isPlaying = true;
        } else {
          target.pause();
          this.isPlaying = false;
        }
        this.updatePlayPauseButtonState();
        return;
      }

      const type = target.dataset?.type;
      if (type === "youtube") {
        if (this.isPlaying) {
          target.youtubePause?.();
        } else {
          if (!this.autoplay) window.pauseAllMedia(target);
          target.youtubePlay?.();
        }
      } else if (type === "vimeo") {
        if (this.isPlaying) {
          target.vimeoPause?.();
        } else {
          if (!this.autoplay) window.pauseAllMedia(target);
          target.vimeoPlay?.();
        }
      }

      this.isPlaying = !this.isPlaying;
      this.updatePlayPauseButtonState();
    });

    this.updatePlayPauseButtonState();
  }

  setupMuteButton(btn, target) {
    this.muteButton = btn;
    this.muteTarget = target;

    btn.classList.add("is-loaded");
    btn.disabled = false;
    btn.setAttribute("aria-hidden", "false");
    btn.setAttribute("tabindex", "0");

    const iconMuted  = btn.querySelector(".js-deferred-video-muted-button-icon-muted");
    const iconUnmuted = btn.querySelector(".js-deferred-video-muted-button-icon-unmuted");
    if (!iconMuted || !iconUnmuted) return;

    this.isMuted = (target.tagName === "VIDEO" ? target.muted : true);
    if (this.autoplay) {
      btn.classList.add("is-autoplay");
      this.isMuted = true
    }

    this.updateMuteButtonState = () => {
      if (!this.isMuted) {
        iconMuted.classList.add("visually-hidden");
        iconMuted.setAttribute("aria-hidden", "true");
        iconUnmuted.classList.remove("visually-hidden");
        iconUnmuted.setAttribute("aria-hidden", "false");
      } else {
        iconMuted.classList.remove("visually-hidden");
        iconMuted.setAttribute("aria-hidden", "false");
        iconUnmuted.classList.add("visually-hidden");
        iconUnmuted.setAttribute("aria-hidden", "true");
      }
    };

    btn.addEventListener("click", () => {
      if (target.tagName === "VIDEO") {
        if (target.muted) {
          target.muted = false;
          this.isMuted = false;
        } else {
          target.muted = true;
          this.isMuted = true;
        }
        this.updateMuteButtonState();
        return;
      }

      this.isMuted = !this.isMuted;
      this.updateMuteButtonState();
    });

    this.updateMuteButtonState();
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 200,
    });
  }

  init() {
    const resizeObserver = new ResizeObserver(() => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0,
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / this.sliderItemOffset,
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        }),
      );
    }

    if (this.currentPage === 1 && this.currentPage === this.totalPages) {
      this.classList.add("slider--no-buttons");
    } else {
      this.classList.remove("slider--no-buttons");
    }

    if (this.enableSliderLooping) return;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (isFirstSlide || this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      isLastSlide ||
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();

    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slideScrollPosition = theme.config.rtl
      ? this.slideScrollPosition * -1
      : this.slideScrollPosition;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}
customElements.define("slider-component", SliderComponent);

class ThumbnailSlider extends SliderComponent {
  constructor() {
    super();
  }

  init() {
    super.init();

    const variantItems = this.querySelectorAll(
      ".thumbnail-list_item--variant:not(.is-active)",
    );
    this.slider.dataset.mediaCount =
      this.sliderItems.length - variantItems.length;

    if (this.querySelector("[data-gang-option]")) {
      const inactiveGangItems = this.querySelectorAll(
        "[data-gang-option]:not(.gang__active)",
      );
      this.slider.dataset.mediaCount =
        this.sliderItems.length - inactiveGangItems.length;
    }

    if (this.slider.dataset.mediaCount < 2) this.classList.add("hidden");
  }
}
customElements.define("thumbnail-slider", ThumbnailSlider);

class QuoteSlider extends SliderComponent {
  constructor() {
    super();
  }

  update() {
    super.update();

    if (this.currentPageElement && this.pageTotalElement) {
      this.sliderItems.forEach((element) => {
        element.removeAttribute("aria-current");
      });

      const currentElement = this.sliderItemsToShow[this.currentPage - 1];
      currentElement.setAttribute("aria-current", true);
    }
  }
}
customElements.define("quote-slider", QuoteSlider);

class ProductGallery extends SliderComponent {
  constructor() {
    super();
  }

  init() {
    super.init();

    const gallerySliderButtons = this.querySelector(".slider-buttons");
    if (gallerySliderButtons && this.querySelector("[data-gang-option]")) {
      if (
        this.querySelectorAll(".product__media-item.gang__active").length < 2
      ) {
        gallerySliderButtons.classList.add("hidden");
      } else {
        gallerySliderButtons.classList.remove("hidden");
      }
    }

    this.cursor = this.querySelector(".gallery-cursor");
    if (!this.cursor) return;

    const images = this.querySelectorAll(".product__modal-opener--image");
    images.forEach((image) =>
      image.addEventListener("mousemove", this.onMoveHandler.bind(this)),
    );
    images.forEach((image) =>
      image.addEventListener("mouseenter", this.onEnterHandler.bind(this)),
    );
    images.forEach((image) =>
      image.addEventListener("mouseleave", this.onLeaveHandler.bind(this)),
    );
  }

  onMoveHandler(event) {
    this.cursor.style.left = `${event.clientX - 32}px`;
    this.cursor.style.top = `${event.clientY - 32}px`;
  }

  onEnterHandler() {
    this.cursor.classList.add("show");
  }

  onLeaveHandler() {
    this.cursor.classList.remove("show");
  }

  update() {
    super.update();

    if (this.currentPageElement && this.pageTotalElement) {
      const currentElement = this.sliderItemsToShow[this.currentPage - 1];
      if (currentElement) {
        this.slider.style.setProperty(
          "--force-image-ratio-percent",
          currentElement
            .querySelector(".media")
            .style.getPropertyValue("--image-ratio-percent"),
        );
      }
    }
  }

  goToFirstSlide() {
    this.slider.scrollTo({
      left: 0,
    });
  }
}
customElements.define("product-gallery", ProductGallery);

class VariantSelects extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.validateGang();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      if (this.gangOption) {
        this.updateGangMedia();
      }
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateThumbnailsByVariant();

      document.dispatchEvent(new CustomEvent('variant:changed', { detail: this.currentVariant }));
    }

    this.handleStickyCart(event.target);

    if (
      this.currentVariant.available === false &&
      $(".klaviyo-bis-trigger").length > 0
    ) {
      $(".klaviyo-bis-trigger").removeClass("hidden");
      $(".klaviyo-bis-trigger").attr("data-variant-id", this.currentVariant.id);
    }
    if (this.currentVariant.available === true && $(".klaviyo-bis-trigger").length > 0) {
      $(".klaviyo-bis-trigger").addClass("hidden");
      $(".klaviyo-bis-trigger").attr("data-variant-id", this.currentVariant.id);
    }
  }

  handleStickyCart(target) {
    const stickyCart = document.getElementById(
      `sticky-cart-${this.dataset.section}`,
    );
    if (!stickyCart) return;

    const attribute = target.getAttribute("name");

    document
      .querySelectorAll(
        `variant-radios[data-section="${this.dataset.section}"] [name="${attribute}"], variant-selects[data-section="${this.dataset.section}"] [name="${attribute}"]`,
      )
      .forEach((input) => {
        if (input.tagName === "INPUT") {
          input.checked = input.value === target.value;
        } else {
          input.value = target.value;
        }
      });

    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const image = document.querySelector(".sticky-cart__content-image img");
    if (image) {
      image.srcset = `${this.currentVariant.featured_media.preview_image.src}&width=70 1x, ${this.currentVariant.featured_media.preview_image.src}&width=140 2x`;
      image.src = `${this.currentVariant.featured_media.preview_image.src}&width=70`;
      image.width = 70;
      image.height = Math.ceil(
        70 / this.currentVariant.featured_media.preview_image.aspect_ratio,
      );
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value,
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  validateGang() {
    const mediaItemWithGang = document.querySelector(
      `#shopify-section-${this.dataset.section} [data-gang-option]`,
    );
    if (mediaItemWithGang) {
      this.gangOption = mediaItemWithGang.dataset.gangOption;
    }
  }

  updateGangMedia() {
    if (!this.gangOption) return;

    const variantInputWrapper = this.querySelector(
      '.variant-input-wrapper[data-option-slug="' + this.gangOption + '"]',
    );
    if (variantInputWrapper) {
      this.gangIndex = variantInputWrapper.dataset.optionIndex;
    } else {
      this.gangOption = null;
    }

    if (!this.currentVariant) return;
    //if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.section}`,
    );
    const gangValue = this.getSlug(this.currentVariant[this.gangIndex]);
    if (this.currentGangValue !== gangValue) {
      document
        .querySelectorAll(
          `#shopify-section-${this.dataset.section} [data-gang-connect]`,
        )
        .forEach(function (media) {
          media.classList.remove("gang__active");
        });

      this.currentGangValue = gangValue;
      var gangConnect = this.gangOption + "_" + gangValue;
      const newMedias = document.querySelectorAll(
        `#shopify-section-${this.dataset.section} [data-gang-connect="${gangConnect}"]`,
      );

      if (!newMedias.length) return;
      Array.from(newMedias)
        .reverse()
        .forEach(function (newMedia) {
          newMedia.classList.add("gang__active");
          let parent = newMedia.parentElement;
          if (parent.firstChild != newMedia) {
            parent.prepend(newMedia);
            parent.classList.add("product__media-no-animate");
          }
        });

      const thumbnailSlider = document.getElementById(
        `GalleryThumbnails-${this.dataset.section}`,
      );
      if (thumbnailSlider) {
        const inactiveItems = thumbnailSlider.querySelectorAll(
          ".thumbnail-list__item:not(.gang__active)",
        );
        thumbnailSlider.slider.dataset.mediaCount =
          thumbnailSlider.sliderItems.length - inactiveItems.length;
        if (thumbnailSlider.slider.dataset.mediaCount < 2) {
          thumbnailSlider.classList.add("hidden");
        } else {
          thumbnailSlider.classList.remove("hidden");
        }
        thumbnailSlider.resetPages();
      }

      if (!mediaGallery) {
        const productGallery = document.querySelector(
          `#shopify-section-${this.dataset.section} product-gallery`,
        );
        if (productGallery) {
          productGallery.resetPages();
          productGallery.goToFirstSlide();
        }
      }

      const gallerySliderButtons = document.querySelector(
        `#shopify-section-${this.dataset.section} product-gallery .slider-buttons`,
      );
      if (gallerySliderButtons) {
        if (
          document.querySelectorAll(
            `#shopify-section-${this.dataset.section} product-gallery .product__media-item.gang__active`,
          ).length < 2
        ) {
          gallerySliderButtons.classList.add("hidden");
        } else {
          gallerySliderButtons.classList.remove("hidden");
        }
      }
    }

    if (!this.currentVariant.featured_media) {
      if (
        !document.querySelectorAll(
          `#shopify-section-${this.dataset.section} product-gallery .product__media-item.gang__active.is-active`,
        ).length
      ) {
        document
          .querySelector(
            `#shopify-section-${this.dataset.section} product-gallery .product__media-item.gang__active`,
          )
          .classList.add("is-active");
      }
      return;
    }

    if (mediaGallery) {
      const scrollIntoView = typeof this.dataset.noScroll === "undefined";
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true,
        scrollIntoView,
      );
    }

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} [modal-media-content]`,
    );
    if (modalContent) {
      const newMediaModal = modalContent.querySelector(
        `[data-media-id="${this.currentVariant.featured_media.id}"]`,
      );
      modalContent.prepend(newMediaModal);
    }

    const thumbnailContent = document.querySelector(
      `#ProductThumbnails-${this.dataset.section}`,
    );
    if (thumbnailContent) {
      const newMediaThumbnail = thumbnailContent.querySelector(
        `[data-media-id="${this.currentVariant.featured_media.id}"]`,
      );
      thumbnailContent.prepend(newMediaThumbnail);
    }
  }

  getSlug(someString) {
    return someString
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/-$/, "")
      .replace(/^-/, "");
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`,
    );

    if (!newMedia) return;

    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    parent.prepend(newMedia);
    parent.classList.add("product__media-no-animate");

    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.section}`,
    );
    if (mediaGallery) {
      const scrollIntoView = typeof this.dataset.noScroll === "undefined";
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true,
        scrollIntoView,
      );
    }

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} [modal-media-content]`,
    );

    if (modalContent) {
      const newMediaModal = modalContent.querySelector(
        `[data-media-id="${this.currentVariant.featured_media.id}"]`,
      );
      modalContent.prepend(newMediaModal);
    }

    const thumbnailContent = document.querySelector(
      `#ProductThumbnails-${this.dataset.section}`,
    );
    if (thumbnailContent) {
      const newMediaThumbnail = thumbnailContent.querySelector(
        `[data-media-id="${this.currentVariant.featured_media.id}"]`,
      );
      thumbnailContent.prepend(newMediaThumbnail);
    }
  }

  updateThumbnailsByVariant() {
    const thumbnailGallery = document.querySelector(
      `#GalleryThumbnails-${this.dataset.section}`,
    );
    if (thumbnailGallery) {
      const variantTitle = this.currentVariant.title;
      let firstImg = null
      thumbnailGallery
        .querySelectorAll(".thumbnail-list__item")
        .forEach((img) => {
          if (
            typeof img.getAttribute("data-alt") !== undefined &&
            img.getAttribute("data-alt") !== ""
          ) {
            if (
              img.getAttribute("data-alt").includes(variantTitle) ||
              !img.getAttribute("data-alt").includes('|')
            ) {
              img.style.display = "block";
              if(!firstImg) firstImg = img
            } else {
              img.style.display = "none";
            }
          }
        });

      if(firstImg) {
        firstImg.querySelector('button').click()
      }
    }

    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.section}`,
    );
    if (mediaGallery) {
      const productGallery = document.querySelector("product-gallery");
      const variantTitle = this.currentVariant.title;
      productGallery
        .querySelectorAll(".product__media-item")
        .forEach((img) => {
          if (
            typeof img.getAttribute("data-alt") !== undefined &&
            img.getAttribute("data-alt") !== ""
          ) {
            if (
              img.getAttribute("data-alt").includes(variantTitle) ||
              !img.getAttribute("data-alt").includes('|')
            ) {
              img.style.display = "block";
            } else {
              img.style.display = "none";
            }
          }

          if (img.classList.contains("is-active")) {
            img.style.display = "block";
          }
        });

      productGallery.resetPages();
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment, #product-form-${this.dataset.section}--alt`,
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`,
    )
      .then((response) => response.text())
      .then((responseText) => {
        this.updateSKU(responseText);
        this.updatePrice(responseText);
        this.updatePriceAlt(responseText);
        this.updateColorName(responseText);
        this.updateSizeName(responseText);
        this.updateInventoryStatus(responseText);
        if (this.currentVariant)
          this.toggleAddButton(
            !this.currentVariant.available,
            variantStrings.soldOut,
          );
      })
      .catch((e) => {
        //console.error(e);
      });
  }

  updateSKU(responseText) {
    const id = `sku-${this.dataset.section}`;
    const html = new DOMParser().parseFromString(responseText, "text/html");
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;
    if (destination) destination.classList.remove("visibility-hidden");

    let variantSizeMeta = document.querySelector(
      '.variant-size-meta[data-id="' + this.currentVariant.id + '"]',
    );
    let currentSize = "";

    if (variantSizeMeta) {
      currentSize = document.querySelector(
        '.variant-size-meta[data-id="' + this.currentVariant.id + '"]',
      ).textContent;
    }

    if (currentSize !== "" && currentSize !== 0) {
      if(document.querySelector(".product__main-info .product__size-meta")) {
        document.querySelector(
          ".product__main-info .product__size-meta",
        ).textContent = currentSize + " • ";
      }
    } else {
      if(document.querySelector(".product__size-meta")) {
        document.querySelector(".product__size-meta").textContent = "";
      }
    }
  }

  updatePrice(responseText) {
    const id = `price-${this.dataset.section}`;
    const html = new DOMParser().parseFromString(responseText, "text/html");
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;
    if (destination) destination.classList.remove("visibility-hidden");
  }

  updatePriceAlt(responseText) {
    const id = `price-${this.dataset.section}--alt`;
    const html = new DOMParser().parseFromString(responseText, "text/html");
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;
    if (destination) destination.classList.remove("visibility-hidden");
  }

  updateColorName(responseText) {
    const id = `color-${this.dataset.section}`;
    const html = new DOMParser().parseFromString(responseText, "text/html");
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;
    if (destination) destination.classList.remove("visibility-hidden");
  }

  updateSizeName(responseText) {
    const id = `size-${this.dataset.section}`;
    const html = new DOMParser().parseFromString(responseText, "text/html");
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;
    if (destination) destination.classList.remove("visibility-hidden");
  }

  updateInventoryStatus(responseText) {
    const id = `inventory-${this.dataset.section}`;
    const html = new DOMParser().parseFromString(responseText, "text/html");
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;
    if (destination) destination.classList.remove("visibility-hidden");
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-${this.dataset.section}--alt`,
    );
    const hideButton = this.currentVariant.available === true && $(".klaviyo-bis-trigger").length > 0;

    for (const productForm of productForms) {
      const addButton = productForm.querySelector('[name="add"]');
      if (!addButton) continue;

      if (!hideButton) {
        addButton.setAttribute("disabled", true);
        addButton.classList.add("hidden");
        if (text) addButton.textContent = text;
      } else {
        addButton.removeAttribute("disabled");
        addButton.classList.remove("hidden");
        addButton.textContent =
          addButton.dataset.preOrder === "true"
            ? variantStrings.preOrder
            : variantStrings.addToCart;
      }

      if (!modifyClass) continue;
    }
  }

  setUnavailable() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-${this.dataset.section}--alt`,
    );
    productForms.forEach((productForm) => {
      const addButton = productForm.querySelector('[name="add"]');
      if (!addButton) return;
      addButton.textContent = variantStrings.unavailable;
      addButton.classList.add("hidden");

      const price = document.getElementById(`price-${this.dataset.section}`);
      if (price) price.classList.add("visibility-hidden");

      const priceAlt = document.getElementById(
        `price-${this.dataset.section}--alt`,
      );
      if (priceAlt) priceAlt.classList.add("visibility-hidden");

      const inventory = document.getElementById(
        `inventory-${this.dataset.section}`,
      );
      if (inventory) inventory.classList.add("visibility-hidden");
    });
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked,
      ).value;
    });
  }
}
customElements.define("variant-radios", VariantRadios);

class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.miniCart = document.querySelector("mini-cart");
    this.form = this.querySelector("form");
    this.form.querySelector("[name=id]").disabled = false;
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.onQuantityChangeBound = this.onQuantityChange.bind(this);
  }

  connectedCallback() {
    this.addEventListener("quantity-change", this.onQuantityChangeBound);
  }

  onQuantityChange(evt) {
    const stickyCart = document.querySelector("product-sticky-cart");
    const quantityInput = evt.target.closest("quantity-input");
    if (!stickyCart || !quantityInput) return;
    if (quantityInput.input.getAttribute("name") !== 'quantity') return;
    const newQty = quantityInput.input.value > 0 ? quantityInput.input.value : 1;
    stickyCart.querySelector("quantity-input").input.value = newQty;
  }

  disconnectedCallback() {
    this.removeEventListener("quantity-change", this.onQuantityChangeBound);
  }

  onSubmitHandler(evt) {
    if (
      document.body.classList.contains("template-cart") ||
      !shopSettings.cartDrawer
    ) {
      return;
    }

    evt.preventDefault();
    const submitButton = this.querySelector('[type="submit"]');
    if (submitButton.classList.contains("loading")) {
      return;
    }

    this.handleErrorMessage();

    submitButton.setAttribute("aria-disabled", true);
    submitButton.classList.add("loading");

    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];

    const formData = new FormData(this.form);

    if (this.miniCart) {
      formData.append(
        "sections",
        this.miniCart.getSectionsToRender().map((section) => section.id),
      );
    }
    formData.append("sections_url", window.location.pathname);
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }

        if (typeof GTMDataLayer !== 'undefined' && response) {
          const qty = Number(formData.get('quantity')) || 1
          const item = {
            item_name: response.product_title,
            item_id: response.product_id.toString(),
            price: response.price / 100,
            item_brand: response.vendor || '',
            item_category: response.product_type || '',
            item_variant_id: response.variant_id.toString(),
            item_variant: response.variant_title || '',
            quantity: qty
          };
          GTMDataLayer.addToCart(item, (response.price * qty) / 100, window.shopSettings?.isoCode || 'USD');
        }

        if (window.promo_buyX_getY) {
          const promoStart =
            new Date(window.promo_buyX_getY.dataStart).getTime() +
            window.promo_buyX_getY.timeZone * 60 * 1000;
          const promoFinish =
            new Date(window.promo_buyX_getY.dataEnd).getTime() +
            window.promo_buyX_getY.timeZone * 60 * 1000;
          const customer_time =
            new Date().getTimezoneOffset() * 60 * 1000 + Date.now();

          var promo_buyX_getY_in_cart = false;
          fetch("/cart.json")
            .then((responseCart) => responseCart.json())
            .then((cart) => {
              cart.items.forEach(function (cartItem, i) {
                if (
                  cartItem.properties &&
                  cartItem.properties["_product-type"]
                ) {
                  if (cartItem.properties["_product-type"] == "gift") {
                    promo_buyX_getY_in_cart = true;
                  }
                }
              });

              if (
                !promo_buyX_getY_in_cart &&
                response.product_id ===
                  window.promo_buyX_getY.mainProductTrigger &&
                promoStart < customer_time &&
                customer_time < promoFinish
              ) {
                const sections = this.miniCart
                  ? this.miniCart
                      .getSectionsToRender()
                      .map((section) => section.id)
                  : [];
                const body = JSON.stringify({
                  items: [
                    {
                      id: window.promo_buyX_getY.productGift,
                      quantity: 1,
                      properties: {
                        "_product-type": "gift",
                      },
                    },
                  ],
                  sections: sections,
                  sections_url: window.location.pathname,
                });

                fetch(`${routes.cart_add_url}`, {
                  ...fetchConfig("javascript"),
                  body,
                })
                  .then((cartAddResponse) => cartAddResponse.json())
                  .then((cartAddParsedState) => {
                    if (this.miniCart) {
                      this.miniCart.renderContents(response);
                    }
                  });
              } else {
                if (this.miniCart) {
                  this.miniCart.renderContents(response);
                }
              }
            });
        } else if (window.promo_gwp) {
          fetch("/cart.json")
            .then((responseCart) => responseCart.json())
            .then((cart) => {
              const alreadyInCart = cart.items.some(
                (i) => i.properties?.["_product-type"] === "gift_promo_gwp"
              );
              if (!alreadyInCart && window.promo_gwp.productGift && window.gwpQualifies(cart)) {
                const sections = this.miniCart
                  ? this.miniCart.getSectionsToRender().map((section) => section.id)
                  : [];
                const body = JSON.stringify({
                  items: [{
                    id: window.promo_gwp.productGift,
                    quantity: 1,
                    properties: { "_product-type": "gift_promo_gwp" },
                  }],
                  sections: sections,
                  sections_url: window.location.pathname,
                });
                fetch(`${routes.cart_add_url}`, { ...fetchConfig("javascript"), body })
                  .then((cartAddResponse) => cartAddResponse.json())
                  .then((cartAddParsedState) => {
                    if (this.miniCart) this.miniCart.renderContents(cartAddParsedState);
                  });
              } else {
                if (this.miniCart) this.miniCart.renderContents(response);
              }
            });
        } else {
          if (this.miniCart) {
            this.miniCart.renderContents(response);
          }
        }
      })
      .catch((e) => {
        //console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove("loading");
        submitButton.removeAttribute("aria-disabled");
      });
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper =
      this.errorMessageWrapper ||
      this.querySelector(".product-form__error-message-wrapper");

    if (this.errorMessageWrapper) {
      this.errorMessage =
        this.errorMessage ||
        this.errorMessageWrapper.querySelector(".product-form__error-message");
      this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    } else {
      if (errorMessage) {
        let sticky = document.querySelector(
          "product-sticky-cart .sticky-bar--error",
        );
        if (sticky) {
          sticky.append(errorMessage);
        } else {
          alert(errorMessage);
        }
      }
    }
  }
}
customElements.define("product-form", ProductForm);

class ShowMoreText extends HTMLElement {
  constructor() {
    super();
    this.textElement = this.querySelector('.product__text');
    this.isExpanded = false;
    this.needsToggle = false;

    this.init();
  }

  init() {
    // Create toggle button
    this.toggleButton = document.createElement('button');
    this.toggleButton.className = 'toggle-button';
    this.toggleButton.innerHTML = '<span class="more-text">READ MORE</span>';
    this.appendChild(this.toggleButton);

    // Add event listener
    this.toggleButton.addEventListener('click', () => this.toggle());

    // Check if toggle is needed
    this.checkOverflow();

    // Listen for resize events
    window.addEventListener('resize', () => this.checkOverflow());
  }

  checkOverflow() {
    const lineHeight = parseFloat(window.getComputedStyle(this.textElement).lineHeight);
    const maxHeight = lineHeight * 2; // 2 lines

    this.needsToggle = this.textElement.scrollHeight > maxHeight;

    if (this.needsToggle) {
      this.toggleButton.classList.add('visible');
    } else {
      this.toggleButton.classList.remove('visible');
      this.collapse();
    }
  }

  toggle() {
    if (this.isExpanded) {
      this.collapse();
    } else {
      this.expand();
    }
  }

  expand() {
    this.isExpanded = true;
    this.classList.add('expanded');
    this.querySelector('.more-text').style.display = 'none';
    this.querySelector('.less-text').style.display = 'inline';
  }

  collapse() {
    this.isExpanded = false;
    this.classList.remove('expanded');
    this.querySelector('.more-text').style.display = 'inline';
    this.querySelector('.less-text').style.display = 'none';
  }
}
customElements.define("show-more-text", ShowMoreText);

class ProgressBar extends HTMLElement {
  constructor() {
    super();

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 0,
    });
  }

  init() {
    setTimeout(() => {
      const quantity = parseInt(this.dataset.quantity);
      this.style.setProperty(
        "--progress-bar-width",
        `${(quantity * 100) / 30}%`,
      );
    }, 1e3);
  }
}
customElements.define("progress-bar", ProgressBar);

class FormState extends HTMLElement {
  constructor() {
    super();

    this.formInputs = this.querySelectorAll("input,select,textarea");
    this.form = this.querySelector("form");

    this.formInputs.forEach((input) => {
      input.addEventListener("input", this.onInputChange.bind(this));
      input.addEventListener("blur", this.onInputChange.bind(this));
    });

    if (this.form)
      this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
  }

  onInputChange(event) {
    this.handleInputCheck(event.target);
  }

  onSubmitHandler(event) {
    let valid = !0;

    this.formInputs.forEach((input) => {
      if (!this.handleInputCheck(input)) {
        valid = !1;
      }
    });

    if (!valid) {
      event.preventDefault();
      return;
    }
  }

  handleInputCheck(input) {
    if (input.classList.contains("required")) {
      if (input.value.length === 0 || input.value === input.dataset.empty) {
        input.classList.remove("valid");
        input.classList.add("invalid");

        return !1;
      } else {
        input.classList.remove("invalid");
        input.classList.add("valid");

        return !0;
      }
    }

    return !0;
  }
}
customElements.define("form-state", FormState);

class ListMenuItem extends HTMLElement {
  constructor() {
    super();

    this.listMenuHover =
      this.closest("menu-drawer").querySelector("list-menu-hover");

    this.addEventListener("mouseenter", () => {
      if (this.listMenuHover) {
        this.listMenuHover.open({
          title: this.dataset.title,
          url: this.dataset.url,
          image: this.dataset.image,
          description: this.dataset.description,
        });
      }
    });
  }
}
customElements.define("list-menu-item", ListMenuItem);

class ListMenuHover extends HTMLElement {
  constructor() {
    super();
  }

  open(obj) {
    let html = "";
    const opened = obj.image.length > 0 || obj.description.length > 0;

    if (opened) {
      html += `<a href="${obj.url}" class="hover-collection${obj.image.length > 0 ? "" : " hover-collection--no-image"}">`;
      html +=
        '<figure class="hover-collection__image"' +
        (obj.image.length > 0
          ? `style="background-image:url(${obj.image})"`
          : "") +
        "></figure>";
      html += '<div class="hover-collection__content">';
      html += `<span class="hover-collection__title heading-4">${obj.title}</span>`;
      html +=
        obj.description.length > 0
          ? `<div class="hover-collection__description">${obj.description}</div>`
          : "";
      html += "</div>";
      html += "</a>";
    }

    this.innerHTML = html;
  }

  close() {
    this.innerHTML = "";
  }
}
customElements.define("list-menu-hover", ListMenuHover);

class TransparentHeader extends HTMLElement {
  constructor() {
    super();

    const header = document.getElementById("shopify-section-header");

    header.classList.add("transparent-header");
    if (this.dataset.showSeparator == "true") {
      header.classList.add("transparent-separator");
    }
  }
}
customElements.define("transparent-header", TransparentHeader);

class ColorSwatch extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("mouseenter", this.onHoverHandler.bind(this));
  }

  onHoverHandler() {
    const image = this.closest(".card-wrapper").querySelector(".media img");

    if (image !== null) {
      image.src = this.dataset.src;
      image.srcset = this.dataset.srcset;

      this.activeColorSwatch();
    }
  }

  activeColorSwatch() {
    this.closest(".card__colors")
      .querySelectorAll(".color-swatch")
      .forEach((color) => {
        color.classList.remove("active");
      });

    this.parentNode.classList.add("active");
  }
}
customElements.define("color-swatch", ColorSwatch);

class AddToCart extends HTMLElement {
  constructor() {
    super();
    this.setAttribute("tabindex", "0");
    this.setAttribute("role", "button");

    this.miniCart = document.querySelector("mini-cart");
    this.addEventListener("click", this.onClickHandler.bind(this));
    this.addEventListener("keydown", this.onKeyDownHandler.bind(this));

    this.addEventListener("keydown", (event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        this.click();
      }
    });
  }

  onKeyDownHandler(event) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.onClickHandler();
    }
    this.openMiniCart = this.dataset.position !== "mini-cart";
  }

  onClickHandler() {
    if (
      this.closest(".card-information__button")?.querySelector(".product-card-variants") != null
    ) {
      this.closest(".card-information__button")
        .querySelector(".product-card-variants")
        .classList.add("active");
    } else {
      const variantId = this.dataset.variantId;
      const variantProperty = this.dataset.property;
      let preorderProperties = {};

      if (this.dataset.preorder != undefined) {
        preorderProperties["Pre-Order"] = this.dataset.preorder;
      }

      if (variantId) {
        if (
          document.body.classList.contains("template-cart") ||
          !shopSettings.cartDrawer
        ) {
          Shopify.postLink(routes.cart_add_url, {
            parameters: {
              id: variantId,
              quantity: 1,
            },
          });
          return;
        }

        this.setAttribute("disabled", true);
        this.classList.add("loading");

        const sections = this.miniCart
          ? this.miniCart.getSectionsToRender().map((section) => section.id)
          : [];

        let body;

        if (variantProperty && variantProperty !== "") {
          let ownProperties = { "_product-type": variantProperty };
          body = JSON.stringify({
            id: variantId,
            quantity: 1,
            sections: sections,
            properties: ownProperties,
            sections_url: window.location.pathname,
          });
        } else {
          body = JSON.stringify({
            id: variantId,
            quantity: 1,
            properties: preorderProperties,
            sections: sections,
            sections_url: window.location.pathname,
          });
        }

        fetch(`${routes.cart_add_url}`, { ...fetchConfig("javascript"), body })
          .then((response) => response.json())
          .then((parsedState) => {
            if (typeof GTMDataLayer !== 'undefined' && parsedState && !parsedState.status) {
              const item = {
                item_name: parsedState.product_title,
                item_id: parsedState.product_id.toString(),
                price: parsedState.price / 100,
                item_brand: parsedState.vendor || '',
                item_category: parsedState.product_type || '',
                item_variant_id: parsedState.variant_id.toString(),
                item_variant: parsedState.variant_title || '',
                quantity: 1
              };
              GTMDataLayer.addToCart(item, (parsedState.price * 1) / 100, window.shopSettings?.isoCode || 'USD');
            }

            if (window.promo_buyX_getY) {
              const promoStart = new Date(window.promo_buyX_getY.dataStart).getTime() +
                window.promo_buyX_getY.timeZone * 60 * 1000;
              const promoFinish = new Date(window.promo_buyX_getY.dataEnd).getTime() +
                window.promo_buyX_getY.timeZone * 60 * 1000;
              const customer_time = Date.now() + new Date().getTimezoneOffset() * 60 * 1000;

              if (
                Number(this.dataset.productId) === window.promo_buyX_getY.mainProductTrigger &&
                promoStart < customer_time && customer_time < promoFinish
              ) {
                const promoBody = JSON.stringify({
                  items: [{
                    id: window.promo_buyX_getY.productGift,
                    quantity: 1,
                    properties: { "_product-type": "gift" },
                  }],
                  sections: sections,
                  sections_url: window.location.pathname,
                });

                fetch(`${routes.cart_add_url}`, {
                  ...fetchConfig("javascript"),
                  body: promoBody,
                })
                  .then((res) => res.json())
                  .then((res) => {
                    this.miniCart && this.miniCart.renderContents(res);
                  });
              } else {
                this.miniCart && this.miniCart.renderContents(parsedState);
              }

            } else if (window.promo_gwp) {
              fetch("/cart.json")
                .then((responseCart) => responseCart.json())
                .then((cart) => {
                  const alreadyInCart = cart.items.some(
                    (i) => i.properties?.["_product-type"] === "gift_promo_gwp"
                  );
                  if (!alreadyInCart && window.promo_gwp.productGift && window.gwpQualifies(cart)) {
                    const gwpBody = JSON.stringify({
                      items: [{
                        id: window.promo_gwp.productGift,
                        quantity: 1,
                        properties: { "_product-type": "gift_promo_gwp" },
                      }],
                      sections: sections,
                      sections_url: window.location.pathname,
                    });
                    fetch(`${routes.cart_add_url}`, { ...fetchConfig("javascript"), body: gwpBody })
                      .then((cartAddResponse) => cartAddResponse.json())
                      .then((cartAddParsedState) => {
                        this.miniCart && this.miniCart.renderContents(cartAddParsedState);
                      });
                  } else {
                    this.miniCart && this.miniCart.renderContents(parsedState);
                  }
                });
            } else {
              this.miniCart && this.miniCart.renderContents(parsedState);
            }
          })
          .catch((e) => {
            //console.error(e);
          })
          .finally(() => {
            this.classList.remove("loading");
            this.removeAttribute("disabled");
            if (variantProperty) {
              window.promo.closePopUp?.();
            }
          });
      }
    }
  }
}
customElements.define("add-to-cart", AddToCart);

class CardCTAModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.querySelectorAll('[data-trigger]').forEach(element => {
      element.addEventListener('click', this.onclick.bind(this));
    })
  }

  disconnectedCallback() {
    this.querySelectorAll('[data-trigger]').forEach(element => {
      element.removeEventListener('click', this.onclick.bind(this));
    })
  }

  onclick() {
    this.querySelectorAll('[data-content]').forEach(element => element.classList.toggle('hidden'))
  }
}

customElements.define("card-cta-modal", CardCTAModal);

class CardVariants extends HTMLElement {
  constructor() {
    super();

    this.init()
  }

  init() {
    this.querySelector(".variant-radio-group").addEventListener("sl-change", this.onRadioChange.bind(this));
  }

  onRadioChange(event) {
    const addToCartElement = this.closest(".card-information__button").querySelector("add-to-cart");
    addToCartElement.dataset.variantId = event.target.value;

    // Directly call the cart addition logic instead of triggering click
    const variantId = addToCartElement.dataset.variantId;
    const variantProperty = addToCartElement.dataset.property;
    let preorderProperties = {};

    if (addToCartElement.dataset.preorder != undefined) {
      preorderProperties["Pre-Order"] = addToCartElement.dataset.preorder;
    }

    if (variantId) {
      if (
        document.body.classList.contains("template-cart") ||
        !shopSettings.cartDrawer
      ) {
        Shopify.postLink(routes.cart_add_url, {
          parameters: {
            id: variantId,
            quantity: 1,
          },
        });
        return;
      }

      addToCartElement.setAttribute("disabled", true);
      addToCartElement.classList.add("loading");
      const sections = addToCartElement.miniCart
        ? addToCartElement.miniCart.getSectionsToRender().map((section) => section.id)
        : [];
      let body;

      if (variantProperty && variantProperty != "") {
        let ownProperies = {};
        ownProperies["_product-type"] = variantProperty;
        body = JSON.stringify({
          id: variantId,
          quantity: 1,
          sections: sections,
          properties: ownProperies,
          sections_url: window.location.pathname,
        });
      } else {
        body = JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: preorderProperties,
          sections: sections,
          sections_url: window.location.pathname,
        });
      }

      fetch(`${routes.cart_add_url}`, { ...fetchConfig("javascript"), body })
        .then((response) => response.json())
        .then((parsedState) => {
          if (typeof GTMDataLayer !== 'undefined' && parsedState && !parsedState.status) {
            const item = {
              item_name: parsedState.product_title,
              item_id: parsedState.product_id.toString(),
              price: parsedState.price / 100,
              item_brand: parsedState.vendor || '',
              item_category: parsedState.product_type || '',
              item_variant_id: parsedState.variant_id.toString(),
              item_variant: parsedState.variant_title || '',
              quantity: 1
            };
            GTMDataLayer.addToCart(item, (parsedState.price * 1) / 100, window.shopSettings?.isoCode || 'USD');
          }

          if (window.promo_buyX_getY) {
            const promoStart =
              new Date(window.promo_buyX_getY.dataStart).getTime() +
              window.promo_buyX_getY.timeZone * 60 * 1000;
            const promoFinish =
              new Date(window.promo_buyX_getY.dataEnd).getTime() +
              window.promo_buyX_getY.timeZone * 60 * 1000;
            const customer_time =
              new Date().getTimezoneOffset() * 60 * 1000 + Date.now();

            if (
              Number(addToCartElement.dataset.productId) ==
                window.promo_buyX_getY.mainProductTrigger &&
              promoStart < customer_time &&
              customer_time < promoFinish
            ) {
              const sections = addToCartElement.miniCart
                ? addToCartElement.miniCart
                    .getSectionsToRender()
                    .map((section) => section.id)
                : [];
              const body = JSON.stringify({
                items: [
                  {
                    id: window.promo_buyX_getY.productGift,
                    quantity: 1,
                    properties: {
                      "_product-type": "gift",
                    },
                  },
                ],
                sections: sections,
                sections_url: window.location.pathname,
              });

              fetch(`${routes.cart_add_url}`, {
                ...fetchConfig("javascript"),
                body,
              })
                .then((cartAddResponse) => cartAddResponse.json())
                .then((cartAddParsedState) => {
                  addToCartElement.miniCart && addToCartElement.miniCart.renderContents(cartAddParsedState);
                });
            } else {
              addToCartElement.miniCart && addToCartElement.miniCart.renderContents(parsedState);
            }
          } else if (window.promo_gwp) {
            fetch("/cart.json")
              .then((responseCart) => responseCart.json())
              .then((cart) => {
                const alreadyInCart = cart.items.some(
                  (i) => i.properties?.["_product-type"] === "gift_promo_gwp"
                );
                if (!alreadyInCart && window.promo_gwp.productGift && window.gwpQualifies(cart)) {
                  const sections = addToCartElement.miniCart
                    ? addToCartElement.miniCart.getSectionsToRender().map((section) => section.id)
                    : [];
                  const body = JSON.stringify({
                    items: [{
                      id: window.promo_gwp.productGift,
                      quantity: 1,
                      properties: { "_product-type": "gift_promo_gwp" },
                    }],
                    sections: sections,
                    sections_url: window.location.pathname,
                  });
                  fetch(`${routes.cart_add_url}`, { ...fetchConfig("javascript"), body })
                    .then((cartAddResponse) => cartAddResponse.json())
                    .then((cartAddParsedState) => {
                      if (addToCartElement.miniCart) addToCartElement.miniCart.renderContents(cartAddParsedState);
                    });
                } else {
                  if (addToCartElement.miniCart) addToCartElement.miniCart.renderContents(parsedState);
                }
              });
          } else {
            addToCartElement.miniCart && addToCartElement.miniCart.renderContents(parsedState);
          }
        })
        .catch((e) => {
          //console.error(e);
        })
        .finally(() => {
          addToCartElement.classList.remove("loading");
          addToCartElement.removeAttribute("disabled");
          this.classList.remove("active");
          if (variantProperty) {
            window.promo.closePopUp();
          }
        });
    }
  }
}
customElements.define("card-variants", CardVariants);

class PriceMoney extends HTMLElement {
  constructor() {
    super();

    if (this.shouldInit()) {
      this.init();
    }
  }

  shouldInit() {
    const moneyFormat = shopSettings.moneyFormat.toLowerCase();
    if (moneyFormat.indexOf("class=") !== -1) {
      return false;
    }

    return true;
  }

  init() {
    const currencies_using_comma_decimals =
      "ANG,ARS,BRL,BYN,BYR,CLF,CLP,COP,CRC,CZK,DKK,EUR,HRK,HUF,IDR,ISK,MZN,NOK,PLN,RON,RUB,SEK,TRY,UYU,VES,VND".split(
        ",",
      );
    const symbol = shopSettings.moneyFormat.replace(/\{{.*}}/, "").trim();
    const bdi = this.querySelector("bdi");
    const price = bdi.textContent;
    let html = price.replace(" ", "");
    let money_symbol_decimal = ".";

    if (currencies_using_comma_decimals.includes(shopSettings.isoCode)) {
      money_symbol_decimal = ",";
    }

    if (price.includes(money_symbol_decimal)) {
      if (price.lastIndexOf(symbol) + symbol.length === price.length) {
        const price_without_symbol = price.slice(0, price.lastIndexOf(symbol));
        const price_without_decimal = price.slice(
          0,
          price.lastIndexOf(money_symbol_decimal),
        );
        const decimal = price_without_symbol
          .replace(price_without_decimal, "")
          .trim();
        // html = html.replace(decimal, `<sup class="price__suffix">${decimal}</sup>`);
      } else {
        const price_without_decimal = price.slice(
          0,
          price.lastIndexOf(money_symbol_decimal),
        );
        const decimal = price.replace(price_without_decimal, "").trim();
        // html = html.replace(decimal, `<sup class="price__suffix">${decimal}</sup>`);
      }
    }

    html = html.replace(symbol, `<span class="price__prefix">${symbol}</span>`);

    bdi.innerHTML = html;
  }
}
customElements.define("price-money", PriceMoney);

class SlideshowComponent extends HTMLElement {
  constructor() {
    super();

    this.mql = window.matchMedia("(min-width: 750px)");

    this.elements = {
      small: this.querySelector(".slideshow__left"),
      content: this.querySelector(".slideshow__content"),
      large: this.querySelector(".slideshow__right"),
    };
    this.settings = {
      autorotate: this.dataset.autorotate == "true",
      autorotateSpeed: parseInt(this.dataset.autorotateSpeed),
      slidesSmall: this.elements.small.querySelectorAll(".slideshow__image"),
      slidesLarge: this.elements.large.querySelectorAll(".slideshow__image"),
    };

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 600,
    });
    this.matchMedia();
  }

  init() {
    setTimeout(() => {
      this.flickitySmall = new Flickity(this.elements.small, {
        accessibility: false,
        rightToLeft: theme.config.rtl,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        draggable: false,
        setGallerySize: false,
        autoPlay: this.settings.autorotate
          ? this.settings.autorotateSpeed
          : false,
      });

      this.flickityContent = new Flickity(this.elements.content, {
        accessibility: false,
        rightToLeft: theme.config.rtl,
        prevNextButtons: true,
        pageDots: true,
        wrapAround: true,
        draggable: this.mql.matches ? false : true,
        asNavFor: this.elements.small,
        //adaptiveHeight: true,
        arrowShape:
          "M14.453 30.078q-0.391 1.172-3.125 16.602t-2.539 15.625 16.406 3.125 16.406 2.734 0.195-2.148l0.391-1.563-13.281-2.344q-13.281-2.344-13.281-2.734t2.734-2.344 5.078-3.125q3.906-2.734 9.18-4.688t10.352-2.734q3.516-0.391 8.789-0.391t8.789 0.391q15.625 2.344 28.125 13.281l3.125 2.344 1.563-1.172q1.172-1.172 1.172-1.563t-3.32-3.125-5.273-4.297q-5.078-3.125-11.133-5.664t-11.914-3.711q-3.906-0.781-10.938-0.781t-10.938 0.781q-6.25 1.172-13.281 4.297t-11.719 6.641q-1.563 1.563-1.758 1.367t1.758-12.305l2.344-12.109q0-0.391-1.953-0.781h-1.563q-0.391 0-0.391 0.391z",
        on: {
          ready: () => {
            const prevNextButtons = this.querySelectorAll(".flickity-button");
            if (prevNextButtons) {
              prevNextButtons.forEach((button) => {
                button.setAttribute("tabindex", "-1");
              });
            }
          },
        },
      });

      this.flickityLarge = new Flickity(this.elements.large, {
        accessibility: false,
        rightToLeft: theme.config.rtl,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        draggable: true,
        setGallerySize: false,
        asNavFor: this.elements.content,
      });

      this.bindEvents();

      // Initialize play/pause button state
      if (this.playPauseButton && this.settings.autorotate) {
        this.updatePlayPauseButtonState(false);
      }
    });
  }

  bindEvents() {
    this.flickitySmall.on("scroll", () => {
      this.flickitySmall.slides.forEach((slide, i) => {
        const flickity = this.flickitySmall;
        const image = this.settings.slidesSmall[i];
        let x = 0;

        if (image) {
          if (0 === i) {
            x =
              Math.abs(flickity.x) > flickity.slidesWidth
                ? flickity.slidesWidth +
                  flickity.x +
                  flickity.slides[flickity.slides.length - 1].outerWidth +
                  slide.target
                : slide.target + flickity.x;
          } else if (i === flickity.slides.length - 1) {
            x =
              Math.abs(flickity.x) + flickity.slides[i].outerWidth <
              flickity.slidesWidth
                ? slide.target -
                  flickity.slidesWidth +
                  flickity.x -
                  flickity.slides[i].outerWidth
                : slide.target + flickity.x;
          } else {
            x = slide.target + flickity.x;
          }

          if (!theme.config.isTouch && !theme.config.rtl) {
            image.style.transform = "translateX(" + x * (-1 / 2) + "px)";
          }
        }
      });
    });

    this.flickityLarge.on("scroll", () => {
      this.flickityLarge.slides.forEach((slide, i) => {
        const flickity = this.flickityLarge;
        const image = this.settings.slidesLarge[i];
        let x = 0;

        if (image) {
          if (0 === i) {
            x =
              Math.abs(flickity.x) > flickity.slidesWidth
                ? flickity.slidesWidth +
                  flickity.x +
                  flickity.slides[flickity.slides.length - 1].outerWidth +
                  slide.target
                : slide.target + flickity.x;
          } else if (i === flickity.slides.length - 1) {
            x =
              Math.abs(flickity.x) + flickity.slides[i].outerWidth <
              flickity.slidesWidth
                ? slide.target -
                  flickity.slidesWidth +
                  flickity.x -
                  flickity.slides[i].outerWidth
                : slide.target + flickity.x;
          } else {
            x = slide.target + flickity.x;
          }

          if (!theme.config.isTouch && !theme.config.rtl) {
            image.style.transform = "translateX(" + x * (-1 / 2) + "px)";
          }
        }
      });
    });

    this.elements.content
      .querySelector(".flickity-button.next")
      .addEventListener("click", () => {
        this.flickitySmall.next();
        this.stopPlayer();
        this.pauseAllVideo();
      });

    this.elements.content
      .querySelector(".flickity-button.previous")
      .addEventListener("click", () => {
        this.flickitySmall.previous();
        this.stopPlayer();
        this.pauseAllVideo();
      });

    this.elements.content
      .querySelectorAll(".flickity-page-dot")
      .forEach((button) => {
        button.addEventListener("click", () => {
          this.stopPlayer();
          this.pauseAllVideo();
        });
      });

    // Add play/pause button functionality
    this.playPauseButton = this.querySelector('[data-play-pause-button]');
    if (this.playPauseButton && this.settings.autorotate) {
      this.playPauseButton.addEventListener('click', () => {
        this.togglePlayPause();
      });
    }

    let currentIndex = null,
      swipeDirection = null;

    // Detect swipe direction
    this.flickityLarge.on("dragMove", (_event, _pointer, moveVector) => {
      currentIndex = this.flickityLarge.selectedIndex;
      swipeDirection = this.getSwipeDirection(moveVector);

      this.stopPlayer();
      this.pauseAllVideo();
    });

    // Do stuff based on a successful swipe and it's direction
    this.flickityLarge.on("dragEnd", () => {
      if (this.flickityLarge.selectedIndex !== currentIndex) {
        if (swipeDirection === "left") {
          this.flickitySmall.next();
        } else {
          this.flickitySmall.previous();
        }
      }
    });
  }

  stopPlayer() {
    if (this.settings.autorotate) {
      this.flickitySmall.stopPlayer();
      this.updatePlayPauseButtonState(true);
    }
  }

  togglePlayPause() {
    if (!this.settings.autorotate) return;

    if (this.flickitySmall.player.state === 'playing') {
      this.flickitySmall.stopPlayer();
      this.pauseAllVideo();
      this.updatePlayPauseButtonState(true);
    } else {
      this.flickitySmall.playPlayer();
      this.playAllVideo();
      this.updatePlayPauseButtonState(false);
    }
  }

  updatePlayPauseButtonState(isPaused) {
    if (this.playPauseButton) {
      if (isPaused) {
        this.playPauseButton.classList.add('is-paused');
        this.playPauseButton.setAttribute('aria-label', 'Play slideshow');
      } else {
        this.playPauseButton.classList.remove('is-paused');
        this.playPauseButton.setAttribute('aria-label', 'Pause slideshow');
      }
    }
  }

  pauseAllVideo() {
    this.querySelectorAll(".js-youtube").forEach((video) => {
      video.contentWindow.postMessage(
        '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
        "*",
      );
    });
    this.querySelectorAll(".js-vimeo").forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', "*");
    });
    this.querySelectorAll("video").forEach((video) => {
      video.pause();
    });
  }

  playAllVideo() {
    this.querySelectorAll(".js-youtube").forEach((video) => {
      video.contentWindow.postMessage(
        '{"event":"command","func":"' + "playVideo" + '","args":""}',
        "*",
      );
    });
    this.querySelectorAll(".js-vimeo").forEach((video) => {
      video.contentWindow.postMessage('{"method":"play"}', "*");
    });
    this.querySelectorAll("video").forEach((video) => {
      video.play();
    });
  }

  getSwipeDirection(moveVector) {
    return moveVector.x > 0 ? "right" : "left";
  }

  matchMedia() {
    document.addEventListener("matchSmall", () => {
      this.unload();
      this.init();
    });

    document.addEventListener("unmatchSmall", () => {
      this.unload();
      this.init();
    });
  }

  unload() {
    if (
      this.flickitySmall &&
      typeof this.flickitySmall.destroy === "function"
    ) {
      this.flickitySmall.destroy();
    }
    if (
      this.flickityContent &&
      typeof this.flickityContent.destroy === "function"
    ) {
      this.flickityContent.destroy();
    }
    if (
      this.flickityLarge &&
      typeof this.flickityLarge.destroy === "function"
    ) {
      this.flickityLarge.destroy();
    }
  }
}
customElements.define("slideshow-component", SlideshowComponent);

class SliderProducts extends HTMLElement {
  constructor() {
    super();

    if (this.dataset.blockCount == 1) {
        return;
    }

    this.init();
  }

  init() {
    document.addEventListener("DOMContentLoaded", (event) => {
      this.initSlider();
    });
  }

  initSlider() {
    setTimeout(() => {
      this.flickity = new Flickity(this.querySelector('.products-slider'), {
          accessibility: false,
          prevNextButtons: false,
          pageDots: false,
          autoPlay: false,
          wrapAround: true,
          cellAlign: 'left'
      });
    }, 200);
  }
}

customElements.define('slider-products', SliderProducts);

class TestimonialsComponent extends HTMLElement {
  constructor() {
    super();

    if (this.dataset.slider == "true") {
      this.settings = {
        autorotate: this.dataset.autorotate == "true",
        autorotateSpeed: parseInt(this.dataset.autorotateSpeed),
      };
      this.slider = this.querySelector(".testimonial__list");
      this.previews = this.querySelector(".testimonial__previews");

      theme.initWhenVisible({
        element: this,
        callback: this.init.bind(this),
        threshold: 600,
      });
      theme.initWhenVisible({
        element: this,
        callback: this.update.bind(this),
        threshold: 0,
      });
    }
  }

  init() {
    setTimeout(() => {
      this.flickity = new Flickity(this.slider, {
        accessibility: false,
        rightToLeft: theme.config.rtl,
        prevNextButtons: true,
        arrowShape: { x0: 10, x1: 60, y1: 50, x2: 65, y2: 45, x3: 20 },
        pageDots: false,
        wrapAround: true,
        draggable: true,
        cellAlign: "center",
        autoPlay: this.settings.autorotate
          ? this.settings.autorotateSpeed
          : false,
        pauseAutoPlayOnHover: true,
        asNavFor: this.previews,
      });
      this.flickityNav = new Flickity(this.previews, {
        accessibility: false,
        rightToLeft: theme.config.rtl,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        selectedAttraction: 0.2,
        friction: 0.8,
        adaptiveHeight: true,
      });

      this.flickityNav.previous();
      if (this.settings.autorotate) {
        this.flickity.pausePlayer();
      }

      this.flickity.on(
        "staticClick",
        (_event, _pointer, _cellElement, cellIndex) => {
          if (typeof cellIndex == "number") {
            this.flickityNav.select(cellIndex);
          }
        },
      );

      // Do stuff based on a successful swipe and it's direction
      this.flickity.on("change", (index) => {
        this.flickityNav.select(index);
      });
    });
  }

  update() {
    setTimeout(() => {
      if (this.flickity && this.flickityNav) {
        this.flickityNav.next();
        if (this.settings.autorotate) {
          this.flickity.unpausePlayer();
        }
      }
    }, 300);
  }

  getSwipeDirection(moveVector) {
    return moveVector.x > 0 ? "right" : "left";
  }
}
customElements.define("testimonials-component", TestimonialsComponent);

class UseAnimate extends HTMLElement {
  constructor() {
    super();

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 0,
    });
  }

  init() {
    this.setAttribute("animate", "");
  }
}
customElements.define("use-animate", UseAnimate);

class AnimateSticky extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.onScrollHandler = this.onScroll.bind(this);

    window.addEventListener("scroll", this.onScrollHandler, false);
    this.onScrollHandler();
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScrollHandler);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (
      this.classList.contains("sticky-cart-wrapper") &&
      window.innerWidth > 751
    ) {
      if (scrollTop >= window.innerHeight / 2) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        requestAnimationFrame(this.reset.bind(this));
      }
    } else {
      if (scrollTop >= this.getOffsetTop(this) / 1.5) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        requestAnimationFrame(this.reset.bind(this));
      }
    }
  }

  reveal() {
    this.setAttribute("animate", "");
  }

  reset() {
    this.removeAttribute("animate");
  }

  getOffsetTop(element) {
    let offsetTop = 0;
    while (element) {
      offsetTop += element.offsetTop;
      element = element.offsetParent;
    }
    return offsetTop;
  }
}
customElements.define("animate-sticky", AnimateSticky);

class LookbookComponent extends HTMLElement {
  constructor() {
    super();

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 0,
    });
  }

  init() {
    const hotspots = this.querySelectorAll(".look__hotspot");
    hotspots.forEach((hotspot) => {
      hotspot.classList.add("active");
    });

    setTimeout(() => {
      hotspots.forEach((hotspot) => {
        hotspot.classList.remove("active");
      });
    }, 3e3);
  }
}
customElements.define("lookbook-component", LookbookComponent);

class TabCollage extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll(".tab-collage__heading").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );
    this.querySelectorAll(".tab-collage__heading").forEach((button) =>
      button.addEventListener("mouseover", this.onButtonClick.bind(this)),
    );
  }

  onButtonClick(event) {
    const target = event.target;
    if (target.classList.contains("active")) {
      return;
    }

    this.pauseAllMedia();

    this.querySelectorAll("[data-block-id]").forEach((button) => {
      if (target.dataset.blockId === button.dataset.blockId) {
        button.classList.add("active");
      } else {
        button.classList.remove("active");
      }
    });
  }

  pauseAllMedia() {
    this.querySelectorAll('video-section[data-type="youtube"] iframe').forEach(
      (video) => {
        video.contentWindow.postMessage(
          '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
          "*",
        );
      },
    );
    this.querySelectorAll('video-section[data-type="vimeo"] iframe').forEach(
      (video) => {
        video.contentWindow.postMessage('{"method":"pause"}', "*");
      },
    );
  }
}
customElements.define("tab-collage", TabCollage);

class CountdownTimer extends HTMLElement {
  constructor() {
    super();

    this.parent = this.closest(".product-countdown");
    this.date = new Date(Date.parse(this.dataset.date)).getTime();

    if (isNaN(this.date)) {
      this.date = new Date(this.dataset.date.replace(/-/g, "/")).getTime();

      if (isNaN(this.date)) {
        this.unload();
        return;
      }
    }

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 200,
    });
  }

  init() {
    this.timer();
    this.dataset.interval = setInterval(this.timer.bind(this), 1000);
  }

  timer() {
    const now = new Date(),
      countTo = new Date(this.date),
      timeDifference = countTo - now;

    if (timeDifference < 0) {
      this.unload();
      return;
    }

    const secondsInADay = 60 * 60 * 1000 * 24,
      secondsInAHour = 60 * 60 * 1000;

    const days = Math.floor((timeDifference / secondsInADay) * 1);
    const hours = Math.floor(
      ((timeDifference % secondsInADay) / secondsInAHour) * 1,
    );
    const mins = Math.floor(
      (((timeDifference % secondsInADay) % secondsInAHour) / (60 * 1000)) * 1,
    );
    const secs = Math.floor(
      ((((timeDifference % secondsInADay) % secondsInAHour) % (60 * 1000)) /
        1000) *
        1,
    );

    if (this.dataset.compact == "true") {
      const dayHTML =
        days > 0
          ? `<div class="countdown__item"><span>${days}${dateStrings.d}</span></div>`
          : "";
      const otherHTML = `<div class="countdown__item"><span>${hours > 9 ? hours : "0" + hours}:${mins > 9 ? mins : "0" + mins}:${secs > 9 ? secs : "0" + secs}</span></div>`;

      this.innerHTML = dayHTML + otherHTML;
    } else {
      const dayHTML =
        days > 0
          ? `<div class="countdown__item"><span>${days}</span> ${days == 1 ? dateStrings.day : dateStrings.days}</div>`
          : "";
      const hourHTML = `<div class="countdown__item"><span>${hours}</span> ${hours == 1 ? dateStrings.hour : dateStrings.hours}</div>`;
      const minHTML = `<div class="countdown__item"><span>${mins}</span> ${mins == 1 ? dateStrings.minute : dateStrings.minutes}</div>`;
      const secHTML = `<div class="countdown__item"><span>${secs}</span> ${secs == 1 ? dateStrings.second : dateStrings.seconds}</div>`;

      this.innerHTML = dayHTML + hourHTML + minHTML + secHTML;
    }
  }

  unload() {
    if (this.dataset.interval) {
      clearInterval(this.dataset.interval);
    }

    this.classList.add("hidden");
    if (this.parent) {
      this.parent.classList.add("hidden");
    }
  }
}
customElements.define("countdown-timer", CountdownTimer);

class GMap extends HTMLElement {
  constructor() {
    super();

    if (!this.dataset.apiKey || !this.dataset.mapAddress) {
      return;
    }

    theme.initWhenVisible({
      element: this,
      callback: this.prepMapApi.bind(this),
      threshold: 200,
    });
  }

  prepMapApi() {
    this.loadScript().then(this.initMap.bind(this));
  }

  loadScript() {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      document.body.appendChild(script);
      script.onload = resolve;
      script.onerror = reject;
      script.async = true;
      script.src =
        "https://maps.googleapis.com/maps/api/js?key=" + this.dataset.apiKey;
    });
  }

  initMap() {
    const geocoder = new google.maps.Geocoder();

    geocoder.geocode(
      { address: this.dataset.mapAddress },
      (results, status) => {
        if (status !== google.maps.GeocoderStatus.OK) {
          if (Shopify.designMode) {
          }
        } else {
          const mapOptions = {
            zoom: parseInt(this.dataset.zoom),
            center: results[0].geometry.location,
            draggable: true,
            clickableIcons: false,
            scrollwheel: false,
            disableDoubleClickZoom: true,
            disableDefaultUI: true,
          };

          const map = new google.maps.Map(this, mapOptions),
            center = map.getCenter();

          map.setCenter(center);

          const icon = {
            path: "M32.7374478,5.617 C29.1154478,1.995 24.2994478,0 19.1774478,0 C14.0544478,0 9.23944778,1.995 5.61744778,5.617 C-1.08555222,12.319 -1.91855222,24.929 3.81344778,32.569 L19.1774478,54.757 L34.5184478,32.6 C40.2734478,24.929 39.4404478,12.319 32.7374478,5.617 Z M19.3544478,26 C15.4954478,26 12.3544478,22.859 12.3544478,19 C12.3544478,15.141 15.4954478,12 19.3544478,12 C23.2134478,12 26.3544478,15.141 26.3544478,19 C26.3544478,22.859 23.2134478,26 19.3544478,26 Z",
            fillColor: this.dataset.markerColor,
            fillOpacity: 1,
            anchor: new google.maps.Point(15, 55),
            strokeWeight: 0,
            scale: 0.6,
          };

          new google.maps.Marker({
            map: map,
            position: map.getCenter(),
            icon: icon,
          });

          const styledMapType = new google.maps.StyledMapType(
            JSON.parse(
              this.parentNode.querySelector("[data-gmap-style]").innerHTML,
            ),
          );

          map.mapTypes.set("styled_map", styledMapType);
          map.setMapTypeId("styled_map");

          google.maps.event.addDomListener(window, "resize", function () {
            google.maps.event.trigger(map, "resize");
            map.setCenter(center);
          });
        }
      },
    );
  }
}
customElements.define("g-map", GMap);

class RelatedButtons extends HTMLElement {
  constructor() {
    super();

    window.addEventListener("scroll", this.checkListener.bind(this));
    this.querySelectorAll("a").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );
  }

  checkListener() {
    const element = document.querySelector(this.dataset.scrollto);
    const show = window.scrollY >= element.offsetTop - element.clientHeight;

    if (show) {
      this.classList.add("is-flipped");
    } else {
      this.classList.remove("is-flipped");
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const target = event.target;
    const scrollIntoView = document.querySelector(target.getAttribute("href"));

    scrollIntoView.scrollIntoView({ behavior: "smooth" });
  }
}
customElements.define("related-buttons", RelatedButtons);

class ProductRecentlyViewed extends HTMLElement {
  constructor() {
    super();

    // We save the product ID in local storage to be eventually used for recently viewed section
    if (isStorageSupported("local")) {
      const productId = parseInt(this.dataset.productId);
      const cookieName = "beyours:recently-viewed";
      const items = JSON.parse(window.localStorage.getItem(cookieName) || "[]");

      // We check if the current product already exists, and if it does not, we add it at the start
      if (!items.includes(productId)) {
        items.unshift(productId);
      }

      // By keeping only the 4 most recent
      window.localStorage.setItem(
        cookieName,
        JSON.stringify(items.slice(0, 5)),
      );
    }
  }
}
customElements.define("product-recently-viewed", ProductRecentlyViewed);

class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 600,
    });
  }

  init() {
    fetch(this.dataset.url + this.getQueryString())
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("recently-viewed-products");
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
      })
      .catch((e) => {
        //console.error(e);
      });
  }

  getQueryString() {
    const cookieName = "beyours:recently-viewed";
    const items = JSON.parse(window.localStorage.getItem(cookieName) || "[]");
    if (
      this.dataset.productId &&
      items.includes(parseInt(this.dataset.productId))
    ) {
      items.splice(items.indexOf(parseInt(this.dataset.productId)), 1);
    }
    return items
      .map((item) => "id:" + item)
      .slice(0, 4)
      .join(" OR ");
  }
}
customElements.define("recently-viewed-products", RecentlyViewedProducts);

class BundleProduct extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      souldout: "price--sold-out",
      onsale: "price--on-sale",
      nocompare: "price--no-compare",
    };

    this.price = this.querySelector(".price");
    this.variants = this.querySelector("select");
    if (this.variants) {
      this.variants.addEventListener("change", this.onSelectChange.bind(this));
    }
  }

  onSelectChange(event) {
    const variants = event.target;
    const variant = variants.options[variants.selectedIndex];
    const compare_at_price = parseInt(variant.dataset.compare_at_price || 0);
    const price = parseInt(variant.dataset.price || 0);
    const available = variant.dataset.available === "true";
    const price_varies = variants.dataset.price_varies === "true";
    const compare_at_price_varies =
      variants.dataset.compare_at_price_varies === "true";

    // Remove classes
    this.price.classList.remove(this.classes.souldout);
    this.price.classList.remove(this.classes.onsale);
    this.price.classList.remove(this.classes.nocompare);

    // Add classes
    if (available === false) {
      this.price.classList.add(this.classes.souldout);
    } else if (compare_at_price > price && available) {
      this.price.classList.add(this.classes.onsale);
    }
    if (price_varies == false && compare_at_price_varies) {
      this.price.classList.add(this.classes.nocompare);
    }

    // Change price
    const price__regular = this.querySelector(".price__regular");
    price__regular.querySelector(".price-item--regular").innerHTML =
      `<price-money><bdi>${theme.Currency.formatMoney(price, shopSettings.moneyFormat)}</bdi></price-money>`;

    const price__sale = this.querySelector(".price__sale");
    price__sale.querySelector(".price-item--regular").innerHTML =
      `<price-money><bdi>${theme.Currency.formatMoney(compare_at_price, shopSettings.moneyFormat)}</bdi></price-money>`;
    price__sale.querySelector(".price-item--sale").innerHTML =
      `<price-money><bdi>${theme.Currency.formatMoney(price, shopSettings.moneyFormat)}</bdi></price-money>`;
  }
}
customElements.define("bundle-product", BundleProduct);

class BundleProducts extends HTMLElement {
  constructor() {
    super();

    this.miniCart = document.querySelector("mini-cart");
    this.button = this.querySelector("button");
    if (this.button)
      this.button.addEventListener("click", this.onButtonClick.bind(this));

    this.blocks = this.querySelectorAll("[data-block-id]");
    this.blocks.forEach((block) =>
      block.addEventListener("mouseenter", this.onEnterHandler.bind(this)),
    );
    this.blocks.forEach((block) =>
      block.addEventListener("mouseleave", this.onLeaveHandler.bind(this)),
    );
  }

  onEnterHandler(event) {
    this.classList.add("hovering");

    const target = event.target;
    const blockId = target.dataset.blockId;
    this.blocks.forEach((block) => {
      if (target.nodeName === "BUNDLE-PRODUCT") {
        if (block.nodeName === "BUNDLE-PRODUCT") {
          block.classList.add("active");
          return;
        }
      }
      if (block.dataset.blockId === blockId) {
        block.classList.add("active");
      }
    });
  }

  onLeaveHandler() {
    this.classList.remove("hovering");
    this.blocks.forEach((block) => block.classList.remove("active"));
  }

  onButtonClick(event) {
    event.preventDefault();

    const ids = this.querySelectorAll('[name="id"]');
    const items = {
      items: [...ids]
        .map((e) => e.value)
        .map((e) => ({
          id: e,
          quantity: 1,
        })),
    };

    if (
      document.body.classList.contains("template-cart") ||
      !shopSettings.cartDrawer
    ) {
      Shopify.postLink2(routes.cart_add_url, {
        parameters: {
          ...items,
        },
      });
      return;
    }

    this.handleErrorMessage();

    this.button.setAttribute("disabled", true);
    this.button.classList.add("loading");
    const sections = this.miniCart
      ? this.miniCart.getSectionsToRender().map((section) => section.id)
      : [];

    const body = JSON.stringify({
      ...items,
      sections: sections,
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig("javascript"), body })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }

        if (this.miniCart) {
          this.miniCart.renderContents(response);
        }
      })
      .catch((e) => {
        //console.error(e);
      })
      .finally(() => {
        this.button.classList.remove("loading");
        this.button.removeAttribute("disabled");
      });
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper =
      this.errorMessageWrapper ||
      this.querySelector(".product-form__error-message-wrapper");

    if (this.errorMessageWrapper) {
      this.errorMessage =
        this.errorMessage ||
        this.errorMessageWrapper.querySelector(".product-form__error-message");
      this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    } else {
      if (errorMessage) {
        alert(errorMessage);
      }
    }
  }
}
customElements.define("bundle-products", BundleProducts);

class ShopTheLook extends HTMLElement {
  constructor() {
    super();

    if (this.dataset.blockCount == 1) {
      return;
    }

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 600,
    });
  }

  init() {
    this.products = this.querySelector(".image-with-text__products");

    this.blocks = this.querySelectorAll(
      "lookbook-component [data-block-index]",
    );
    this.blocks.forEach((block) =>
      block.addEventListener("mouseenter", this.onEnterHandler.bind(this)),
    );

    this.initSlider();
  }

  onEnterHandler(event) {
    if (this.flickity && typeof this.flickity.select === "function") {
      const index = parseInt(event.target.dataset.blockIndex);
      this.flickity.select(index);
    }
  }

  onFocusHandler(index) {
    this.blocks.forEach((block) => {
      block.classList.remove("focus");

      if (parseInt(block.dataset.blockIndex) === index) {
        block.classList.add("focus");
      }
    });
  }

  initSlider() {
    this.flickity = new Flickity(this.products, {
      accessibility: false,
      rightToLeft: theme.config.rtl,
      prevNextButtons: false,
      pageDots: true,
      wrapAround: true,
      fade: true,
      setGallerySize: true,
      on: {
        ready: () => {
          this.onFocusHandler(0);
        },
        change: (index) => {
          this.onFocusHandler(index);
        },
      },
    });
  }
}
customElements.define("shop-the-look", ShopTheLook);

class SelectWrapper extends HTMLElement {
  constructor() {
    super();

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 200,
    });

    this.select = this.querySelector("select");
    if (this.select) {
      this.select.addEventListener(
        "change",
        this.handleSelectChange.bind(this),
      );
    }
  }

  init() {
    const style = window.getComputedStyle(this.select);
    const value = this.select.options[this.select.selectedIndex].text;

    const text = document.createElement("span");
    text.style.fontFamily = style.fontFamily;
    text.style.fontSize = style.fontSize;
    text.style.fontWeight = style.fontWeight;
    text.style.visibility = "hidden";
    text.style.position = "absolute";
    text.innerHTML = value;

    document.body.appendChild(text);
    const width = text.clientWidth;

    this.style.setProperty("--width", `${width}px`);
    text.remove();
  }

  handleSelectChange() {
    this.init();
  }
}
customElements.define("select-wrapper", SelectWrapper);

class ImageComparison extends HTMLElement {
  constructor() {
    super();

    this.active = false;
    this.button = this.querySelector("button");
    this.horizontal = this.dataset.layout === "horizontal";
    this.init();

    theme.initWhenVisible({
      element: this.querySelector(".image-comparison__animate"),
      callback: this.animate.bind(this),
      threshold: 0,
    });
  }

  animate() {
    this.setAttribute("animate", "");
    this.classList.add("animating");
    setTimeout(() => {
      this.classList.remove("animating");
    }, 1e3);
  }

  init() {
    if (theme.config.isTouch) {
      this.button.addEventListener("touchstart", this.startHandler.bind(this));
      document.body.addEventListener("touchend", this.endHandler.bind(this));
      document.body.addEventListener("touchmove", this.onHandler.bind(this));
    } else {
      this.button.addEventListener("mousedown", this.startHandler.bind(this));
      document.body.addEventListener("mouseup", this.endHandler.bind(this));
      document.body.addEventListener("mousemove", this.onHandler.bind(this));
    }
  }

  startHandler() {
    this.active = true;
    this.classList.add("scrolling");
  }

  endHandler() {
    this.active = false;
    this.classList.remove("scrolling");
  }

  onHandler(e) {
    if (!this.active) return;

    const event = (e.touches && e.touches[0]) || e;
    const x = this.horizontal
      ? event.pageX - this.offsetLeft
      : event.pageY - this.offsetTop;

    this.scrollIt(x);
  }

  scrollIt(x) {
    const distance = this.horizontal ? this.clientWidth : this.clientHeight;

    const max = distance - 20;
    const min = 20;
    const mouseX = Math.max(min, Math.min(x, max));
    const mousePercent = (mouseX * 100) / distance;
    this.style.setProperty("--percent", mousePercent + "%");
  }
}
customElements.define("image-comparison", ImageComparison);

class ScrollingPromotion extends HTMLElement {
  constructor() {
    super();

    this.config = {
      moveTime: parseFloat(this.dataset.speed), // 100px going to move for
      space: 100, // 100px
    };

    this.promotion = this.querySelector(".promotion");

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 600,
    });
  }

  init() {
    if (this.childElementCount === 1) {
      this.promotion.classList.add("promotion--animated");

      for (let index = 0; index < 10; index++) {
        this.clone = this.promotion.cloneNode(true);
        this.clone.setAttribute("aria-hidden", true);
        this.appendChild(this.clone);

        const imageWrapper = this.clone.querySelector(".media-wrapper");
        if (imageWrapper) {
          imageWrapper.classList.remove("loading");
        }
      }

      const animationTimeFrame =
        (this.promotion.clientWidth / this.config.space) * this.config.moveTime;
      this.style.setProperty("--duration", `${animationTimeFrame}s`);

      // pause when out of view
      const observer = new IntersectionObserver(
        (entries, _observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.scrollingPlay();
            } else {
              this.scrollingPause();
            }
          });
        },
        { rootMargin: "0px 0px 50px 0px" },
      );

      observer.observe(this);
    }
  }

  scrollingPlay() {
    this.classList.remove("scrolling-promotion--paused");
  }

  scrollingPause() {
    this.classList.add("scrolling-promotion--paused");
  }
}
customElements.define("scrolling-promotion", ScrollingPromotion);

if (!customElements.get('video-item')) {
  customElements.define("video-item",
    class VideoItem extends HTMLElement {
      constructor() {
        super();
        this.toggle = this.toggle.bind(this);
      }

      setVariables() {
        this.video = this.querySelector('video')
      }

      connectedCallback() {
        this.setVariables()

        if (this.video) {
          this.querySelectorAll('[data-toggle]').forEach(toggle => {
            toggle.addEventListener('click', this.toggle)
          })
        }
      }

      disconnectedCallback() {
        this.setVariables()
        this.querySelectorAll('[data-toggle]').forEach(toggle => {
          toggle.removeEventListener('click', this.toggle)
        })
      }

      toggle() {
        if (this.classList.contains('playing')) {
          this.pause()
        } else {
          this.play()
        }
      }

      play() {
        this.video?.play()
        this.classList.add('playing')
      }

      pause() {
        this.video?.pause()
        this.classList.remove('playing')
      }
    }
  );
}

class VideoGridItem extends HTMLElement {
  constructor() {
    super();

    let iconPlay = this.querySelector(".video_overlay .icon_play");
    let videoOverlay = this.querySelector(".video_overlay");
    let videoWrapper = this.querySelector(".video--wrapper");
    let video = this.querySelector(".video--wrapper video");
    let autoplay = "false";
    let contentType = "";

    if (this.querySelector(".video--wrapper")) {
      autoplay = this.querySelector(".video--wrapper").dataset.autoplay;
      contentType = this.querySelector(".video--wrapper").dataset.contentType;
    }

    if (contentType === "video") {
      if (autoplay === "true") {
        videoWrapper.addEventListener("mouseenter", function () {
          video.pause();
        });

        videoWrapper.addEventListener("mouseleave", function () {
          video.play();
        });
      } else {
        iconPlay.addEventListener("click", function () {
          video.play();
          videoOverlay.classList.remove("show");
        });

        video.addEventListener("click", function () {
          video.pause();
          videoOverlay.classList.add("show");
        });
      }
    }
  }
}
customElements.define("video-grid-item", VideoGridItem);

if (!customElements.get("popup-for-klaviyo")) {
  class PopUpForKlaviyo extends HTMLElement {
    constructor() {
      super();
      this.sectionOpenButton = document.querySelectorAll(
        'a[href="#klaviyo_popUp"]',
      );
      this.popUp = document.querySelector(".banner__pop-up");
      this.buttonClose = document.querySelector(".banner__pop-up__close");
      this.show();
      this.close();
    }

    show() {
      let _this = this;

      if (_this.sectionOpenButton) {
        _this.sectionOpenButton.forEach(function (el, ind) {
          el.addEventListener("click", function (ev) {
            ev.preventDefault();
            _this.popUp.classList.remove("hidden");
          });
        });
      }
    }

    close() {
      let _this = this;

      if (_this.buttonClose) {
        _this.buttonClose.addEventListener("click", function () {
          _this.popUp.classList.add("hidden");
        });
      }
    }
  }

  customElements.define("popup-for-klaviyo", PopUpForKlaviyo);
}

document.querySelectorAll(".slideshow__button a").forEach((item) => {
  item.addEventListener("click", (ev) => {
    ev.stopPropagation();
    ev.preventDefault();

    const currentDate = new Date(0);
    const currentDateISO = currentDate.toISOString();
    const sliderTitleBlock = ev.target.parentNode.parentNode.querySelector(
      ".slideshow__heading",
    );

    if (sliderTitleBlock != null) {
      let sliderTitle = ev.target.parentNode.parentNode
        .querySelector(".slideshow__heading")
        .textContent.trim();

      hj("event", "click_on_banner_slide_cta", {
        "Signed up": `${currentDateISO}`,
        "Slider title": `${sliderTitle}`,
      });
    }

    window.location.href = ev.target.href;
  });
});

$(".anchor-link").on("click", function (e) {
  e.preventDefault();
  let _this = $(this);
  let currentId = _this.attr("href");

  $("html, body").animate({ scrollTop: $(`${currentId}`).offset().top }, 300);
});

$(".bis-button").on("click", (ev) => {
  $(".bis-popup-wrapper").removeClass("disabled");
});
$(".bis-close").on("click", (ev) => {
  $(".bis-popup-wrapper").addClass("disabled");
});
$(".bis-popup-wrapper").on("click", (ev) => {
  if ($(ev.target).closest(".bis-popup").length === 0) {
    $(".bis-popup-wrapper").addClass("disabled");
  }
});
$(".bis-submit").on("click", (ev) => {
  ev.preventDefault();

  let phoneNumber = $(".bis-phone").val();
  let checkPhone = new RegExp(
    /^[+]?(1\-|1\s|1|\d{3}\-|\d{3}\s|)?((\(\d{3}\))|\d{3})(\-|\s)?(\d{3})(\-|\s)?(\d{4})$/g,
  ).test(phoneNumber);
  let email = $(".bis-email").val();
  let checkEmail = new RegExp(
    /[a-zA-Z0-9.*%±]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}/,
  ).test(email);

  bisValidate(
    phoneNumber,
    checkPhone,
    $(".bis-phone"),
    "Invalid phone number format (Example of a valid format: +1-000-000-0000)",
  );
  bisValidate(
    email,
    checkEmail,
    $(".bis-email"),
    "Invalid email, please check and try again",
  );

  if (
    !$(".bis-phone").hasClass("not-valid-value") &&
    !$(".bis-email").hasClass("not-valid-value")
  ) {
    sendBisToKlaviyo(ev.target.dataset.variantId, email, phoneNumber);
  }
});

$(".bis-phone").on("focus", function () {
  if ($(this).val() === "") {
    $(this).val("+1");
  }
});

$(".bis-popup__form input").on("keyup", function () {
  $(".bis-popup__form input").removeClass("not-valid-value");

  if ($(".error-mgs").length > 0) {
    $(".error-mgs").remove();
  }
  if (
    $(".bis-phone").val() != "" &&
    !$(".bis-phone").hasClass("not-valid-value")
  ) {
    $(".bis-submit")[0].removeAttribute("disabled");
  }
  if (
    $(".bis-email").val() != "" &&
    !$(".bis-email").hasClass("not-valid-value")
  ) {
    $(".bis-submit")[0].removeAttribute("disabled");
  }
});

function bisValidate(value, check, field, msg) {
  let message = $('<p class="error-mgs"></p>').text(msg);

  if (value.trim().length !== 0) {
    if (check === false) {
      field.addClass("not-valid-value");
      if (msg !== "" && $(".error-mgs").length === 0)
        message.insertBefore($(".bis-submit"));
    } else {
      field.removeClass("not-valid-value");
    }
  }
}
function sendBisToKlaviyo(variantID, email, phone) {
  const payload = {
    data: {
      type: "back-in-stock-subscription",
      attributes: {
        profile: {
          data: {
            type: "profile",
            attributes: {},
          },
        },
        channels: ["EMAIL", "SMS"],
      },
      relationships: {
        variant: {
          data: {
            type: "catalog-variant",
            id: `$shopify:::$default:::${variantID}`,
          },
        },
      },
    },
  };

  if (email.trim().length !== 0)
    payload.data.attributes.profile.data.attributes.email = email;
  if (phone.trim().length !== 0)
    payload.data.attributes.profile.data.attributes.phone_number = phone;

  let requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      revision: "2024-06-15",
    },
    body: JSON.stringify(payload),
  };

  fetch(
    "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=SAzqGD",
    requestOptions,
  )
    .then((result) => {
      if (result.ok) {
        let successMessage = $(
          `<p class="bis-success">You're in! We'll let you know when it's back.</p>`,
        );
        successMessage.insertBefore($(".bis-submit"));
        $(".bis-submit").hide();
      } else {
        return Promise.reject(result);
      }
    })
    .catch((response) => {
      response.json().then((json) => {
        if ($(".error-mgs").length === 0) {
          let message = $(`<p class="error-mgs">${json.errors[0].detail}</p>`);
          message.insertBefore($(".bis-submit"));
        }
      });
    });
}

// Adjust fifty-fifty section height
function adjustFiftyFiftyBlocks() {
  const blocks = document.querySelectorAll(".js-fifty-fifty-block");
  blocks.forEach(block => {
    const textEl = block.querySelector(".js-fifty-fifty-text");
    const blockH = block.offsetHeight;
    const textH  = textEl ? textEl.offsetHeight : 0;
    block.style.height = textH > blockH
      ? `${textH}px`
      : "auto";
  });
}

function smoothScroll() {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        const defaultHeaderOffset = 80;
        const header = document.querySelector('#shopify-section-header');
        const headerHeight = header ? header.offsetHeight : defaultHeaderOffset;

        const defaultPromoBarOffset = 40;
        const promoBar = document.querySelector('#shopify-section-announcement-bar');
        const promoBarHeight = promoBar ? promoBar.offsetHeight : defaultPromoBarOffset;

        const targetPosition = target.offsetTop - headerHeight - promoBarHeight;

        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth',
        });
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", adjustFiftyFiftyBlocks);
document.addEventListener("DOMContentLoaded", autoSelectFirstAvailableVariant);
document.addEventListener("DOMContentLoaded", smoothScroll);

window.addEventListener(
  "resize",
  debounce(adjustFiftyFiftyBlocks, 300)
);

// Auto-select first available variant on product pages
function autoSelectFirstAvailableVariant() {
  // Only run on product pages
  // Find the first variant selector
  const variantSelector = document.querySelector('variant-selects, variant-radios');
  if (!variantSelector) {
    return;
  }

  // Check if there's already a variant in the URL
  const urlParams = new URLSearchParams(window.location.search);
  const variantParam = urlParams.get('variant');

  if (variantParam) {
    return; // Variant already selected, don't change
  }

  // Function to attempt auto-selection
  function attemptAutoSelection() {
    try {
      // Get all variants data
      const variantData = variantSelector.getVariantData();
      if (!variantData || variantData.length === 0) {
        return false; // Not ready yet
      }

      // Find the first available variant
      const firstAvailableVariant = variantData.find(variant => variant.available);
      if (!firstAvailableVariant) {
        return true; // No available variants, but we're done
      }

      // Check if the first available variant is already selected
      const currentVariant = variantSelector.currentVariant;
      if (currentVariant && currentVariant.id === firstAvailableVariant.id) {
        return true; // Already selected
      }

      // Auto-select the first available variant
      const selects = variantSelector.querySelectorAll('select');
      const radioGroups = variantSelector.querySelectorAll('fieldset');

      // For dropdown selects
      selects.forEach((select, index) => {
        const targetOption = firstAvailableVariant.options[index];
        if (targetOption) {
          select.value = targetOption;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      // For radio buttons
      radioGroups.forEach((fieldset, index) => {
        const targetOption = firstAvailableVariant.options[index];
        if (targetOption) {
          const radioButton = fieldset.querySelector(`input[value="${targetOption}"]`);
          if (radioButton) {
            radioButton.checked = true;
            radioButton.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });

      return true; // Successfully attempted selection
    } catch (error) {
      console.warn('Auto-select variant error:', error);
      return false;
    }
  }

  // Try immediately, then retry with delays
  if (!attemptAutoSelection()) {
    setTimeout(() => {
      if (!attemptAutoSelection()) {
        setTimeout(attemptAutoSelection, 200);
      }
    }, 100);
  }
}
